{
    "Anonymous.NotAvailable.Heading": "Not available",
    "Anonymous.NotAvailable.Body": "This webinar is not available for anonymous viewing.",

    "Account.ApiErrorCode.Exception": "Something went wrong",
    "Account.ApiErrorCode.NotFoundException": "Account not found",
    "Account.ApiErrorCode.AccessDeniedException": "Invalid email or password",
    "Account.ApiErrorCode.AccountNotVerifiedException": "Account not verified",
    "Account.ApiErrorCode.ConflictException": "Account already exists",
    "Account.ApiErrorCode.LockedOutException": "Account is locked out. Please reset your password to regain access.",
    "Account.ApiErrorCode.ThrottledException": "Too many attempts from your network. Please try again later.",
    "Account.ApiErrorCode.AccountLinkCodeInvalidException": "Invalid code",
    "Account.ApiErrorCode.AccountLinkCodeAlreadyUsedException": "Code has been used",
    "Account.ApiErrorCode.AccountLinkCodeExpiredException": "Code has expired",
    "Account.ApiErrorCode.ImageFormatException": "Invalid image format",
    "Account.Bar.Text": "Managing account of",
    "Account.Button": "My account",
    "Account.Button.ForgotPassword": "Forgot password",
    "Account.Button.ChangePassword": "Change password",
    "Account.Button.ResetPassword": "Reset password",
    "Account.Button.ShowPassword": "Show password",
    "Account.Button.HidePassword": "Hide password",
    "Account.Button.Login": "Login",
    "Account.Button.Register": "Register",
    "Account.Button.Next": "Next",
    "Account.Button.Back": "Back",
    "Account.Button.Cancel": "Cancel",
    "Account.Images.Button.DeleteBannerImage.AriaLabel": "Delete banner image",
    "Account.Images.Button.DeleteProfileImage.AriaLabel": "Delete profile image",
    "Account.Images.Button.UploadBannerImage.AriaLabel": "Upload banner image",
    "Account.Images.Button.UploadProfileImage.AriaLabel": "Upload profile image",
    "Account.Images.Label": "Default webinar profile and banner image",

    "AccountInvite.Button.Reject": "Decline invite",
    "AccountInvite.Info": "You have been invited to join this webinar platform. Please enter your information to create an account, or decline the invitation.",
    "AccountInvite.PageHeading": "You are invited",
    "AccountInvite.AccountLinkCodeAlreadyUsedException": "You already have an account with us",
    "AccountInvite.AccountLinkCodeAlreadyUsedException.Body": "An account has already been created using this invitation link. If you have forgotten your password, you can use the 'Forgot password' feature when logging in.",

    "AccountInvites.PageHeading": "Invite participants to your environment",

    "Account.Management.Button.Invite": "Invite",
    "Account.Management.Button.RemoveAccount": "Remove {{account}}",
    "Account.Management.Heading.InvitedAccounts": "Invited members",
    "Account.Management.InfoText": "Here you can invite other people to manage your webinars. They will be able to: <ul><li>Create and edit webinars</li><li>View insights (statistics)</li><li>Moderate webinars</li><li>Broadcast webinars</li></ul><br>To invite someone, enter the email address of the person you want to invite. An email will then be sent to the person in question.",
    "Account.Management.PageHeading": "Manage account",
    "Account.Management.InviteStatus.Accepted": "accepted",
    "Account.Management.InviteStatus.Pending": "pending",
    "Account.Management.InviteStatus.Rejected": "declined",
    "Account.Label.FirstName": "First name",
    "Account.Label.LastName": "Last name",
    "Account.Label.Nickname": "Nickname",
    "Account.Label.CompanyName": "Company name",
    "Account.Label.Country": "Country",
    "Account.Label.Email": "E-mail",
    "Account.Label.Password": "Password",
    "Account.Label.ForgotPasswordCode": "Forgot password code",
    "Account.Label.CurrentPassword": "Current password",
    "Account.Label.NewPassword": "New password",
    "Account.Label.TermsAndConditions1": "I agree to the ",
    "Account.Label.TermsAndConditions2": "terms and conditions",
    "Account.Link.TermsAndConditions": "https://www.onlinewebinar.com/company/terms-of-service",
    "Account.Menu.Logout": "Log out",
    "Account.Menu.ManageAccount": "Manage account",
    "Account.Menu.NotOnMainAccount": "Account details are not available while managing another account",
    "Account.Menu.Password": "My password",
    "Account.Menu.Profile": "My profile",
    "Account.Menu.SwitchAccount": "Switch account",
    "Account.Menu.Welcome": "Welcome back",
    "Account.Message.SendingEmail": "Sending e-mail to <strong>{{email}}</strong>",
    "Account.Message.ErrorSendingEmail": "Something went wrong while sending the e-mail to <strong>{{email}}</strong>. Please try again later.",
    "Account.Message.EmailSent": "An e-mail has been sent to <strong>{{email}}</strong> with the code to reset your password.",
    "Account.Message.PasswordChanged": "Your password has been changed.",
    "Account.Password.Changed.Message": "Your account password was changed successfully.",
    "Account.Password.PageHeading": "My password",
    "Account.Profile.Changed.Message": "User profile updated successfully.",
    "Account.Profile.PageHeading": "My profile",
    "Account.Profile.NotAvailable": "Profile not available",
    "Account.Profile.NotAvailable.Body": "Your account profile is not available at the moment. This is because you are currently managing another account. Switch back to your own account to view and edit your profile information.",
    "Account.Tab.ApiKeys": "API Keys",
    "Account.Tab.ManageAccount": "Manage account",
    "Account.Tab.Password": "Password",
    "Account.Tab.Profile": "Profile",

    "Account.ApiKeys.PageHeading": "API Keys",
    "Account.ApiKeys.Description": "API keys allow programmatic access to your account. Keep them secret — anyone with a key can act on your behalf.",
    "Account.ApiKeys.Label.Name": "Key name",
    "Account.ApiKeys.Button.Create": "Create API Key",
    "Account.ApiKeys.Button.Dismiss": "Close",
    "Account.ApiKeys.Button.Revoke": "Revoke {{name}}",
    "Account.ApiKeys.Heading.ActiveKeys": "Active API Keys",
    "Account.ApiKeys.CreatedAt": "Created on {{date}}",
    "Account.ApiKeys.Created.Title": "API Key Created",
    "Account.ApiKeys.Created.Warning": "Copy this key now — it won't be shown again.",
    "Account.ApiKeys.Validation.NameRequired": "Key name is required",

    "Account.Validation.EmailRequired": "E-mail address is required",
    "Account.Validation.PasswordRequired": "Password is required",
    "Account.Verification.Failed.Title": "Verification failed",
    "Account.Verification.Pending.Title": "Verifying",
    "Account.Verification.Required.Title": "Account verification required",
    "Account.Verification.Required.Body": "To continue, please verify your account by clicking the link in the email we sent you. To receive a new verification email, click the button below.",
    "Account.Verification.Required.Button": "Resend verification email",
    "Account.Verification.Required.Error": "An error occurred while sending the verification email. Please try again later.",
    "Account.Verification.Required.Success": "A new verification email has been sent to your email address. If you do not see the email in your inbox in a few minutes, please check your spam folder.",
    "Account.Verification.Succeeded.Heading": "Verified",
    "Account.Verification.Succeeded.Subheading": "Thank you!",
    "Account.Verification.Succeeded.Text": "Your account is now verified and you can use the full functionality of the app.",
    "Account.DeleteAccount.Button": "Delete account",
    "Account.DeleteAccount.Confirm.Body": "This will permanently delete your account and all associated data. You will be logged out immediately. This cannot be undone.",
    "Account.DeleteAccount.Confirm.Button": "Yes, delete account",
    "Account.DeleteAccount.Confirm.Title": "Delete your account?",
    "Account.DeleteAccount.PageHeading": "Delete account",
    "Account.DeleteAccount.Warning": "Permanently deletes your account, login credentials, and all account management links. Webinar participation history is kept. This action cannot be undone.",

    "AccountManagerInvite.Button.AcceptInvite": "Accept invite",
    "AccountManagerInvite.Button.RejectInvite": "Decline invite",
    "AccountManagerInvite.InviteBody": "You have been invited to manage webinars for {{name}}. First, please verify your account after which you can let us know if you accept or decline the invitation.",
    "AccountManagerInvite.InviteBodyVerified": "You have been invited to manage webinars for {{name}}. Please let us know if you accept or decline the invitation.",
    "AccountManagerInvite.InviteBody.CombineNameAndCompanyName": "{{name}} of {{companyName}}",
    "AccountManagerInvite.InviteUsed": "The invite link has already been used.",
    "AccountManagerInvite.Invalid": "The invite link is not valid.",
    "AccountManagerInvite.InviteExpired": "Our apologies, your invitation has expired. Please <1>contact</1> {{name}} to request a new link.",
    "AccountManagerInvite.PageHeading": "You have been invited by {{account}}",

    "AccountSwitch.Button.SwitchAccount": "Switch to account {{account}}",
    "AccountSwitch.ManagedAccounts.Heading": "Managed accounts:",
    "AccountSwitch.PageHeading": "Switch account",
    "AccountSwitch.PersonalAccount.Heading": "Personal account:",

    "Beta.Heading": "Beta functionality",
    "Beta.Text.Icon": "Attention: beta functionality",
    "Beta.Text.LiveTranscribe": "Live transcribe is still in beta, so approach with care.",

    "Button.Back": "Back to previous page",
    "Button.BackToContent": "Back to webinar content",
    "Button.BackToInsights": "Back to webinar insights",
    "Button.BackToManageEnv": "Back to manage environment",
    "Button.BackToOrganized": "Back to upcoming webinars",
    "Button.BackToOrganizedEnded": "Back to ended webinars",
    "Button.BackToOverview": "Back to overview",
    "Button.BackToPoll": "Back to poll",

    "Broadcaster.AudioAndVideoSelect.AudioSelect.label": "Select an audio device",
    "Broadcaster.AudioAndVideoSelect.Heading": "Select an audio and video device",
    "Broadcaster.AudioAndVideoSelect.IngestAvailability": "The ingest URL is only available during the alloted timeslot from <strong>{{timeslotstart}}</strong>, until <strong>{{timeslotend}}</strong>. Connection will fail outside of this time frame.",
    "Broadcaster.AudioAndVideoSelect.Quality.label": "Video quality",
    "Broadcaster.AudioAndVideoSelect.Quality.High": "High (1280×720, 4 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.Medium": "Medium (1280×720, 2 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.Low": "Low (854×480, 1 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.HighWarning": "<strong>High quality</strong> needs a fast computer and a stable, high-bandwidth internet connection. Choose Medium or Low if the video freezes or stutters.",
    "Broadcaster.AudioAndVideoSelect.RTMP.Link": "The RTMP URL:",
    "Broadcaster.AudioAndVideoSelect.RTMP.BaseLink": "The RTMP BASE URL:",
    "Broadcaster.AudioAndVideoSelect.RTMP.StreamKey": "The RTMP Stream Key:",
    "Broadcaster.AudioAndVideoSelect.SRT.Link": "The SRT URL:",
    "Broadcaster.AudioAndVideoSelect.SRT.StreamId": "The SRT Stream ID:",
    "Broadcaster.AudioAndVideoSelect.UseClassicConnection.Label": "Use the classic connection (WebRTC)",
    "Broadcaster.AudioAndVideoSelect.UseClassicConnection.InfoText": "By default we broadcast via Media over QUIC. Choose the classic connection if you have problems with your broadcast; your choice is remembered in this browser.",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.label": "Select a video device",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.RTMP": "RTMP device",
    "Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen": "Stop your external encoder first",
    "Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen.Body": "You are switching from an external encoder to your browser. If the encoder is still sending, both will compete for the same channel: your viewers will see the picture drop out and come back over and over until one of them stops. Stop the stream in your encoder before you continue.",
    "Broadcaster.AudioAndVideoSelect.FirefoxWebcamUnavailable": "Broadcasting with your webcam is temporarily unavailable in Firefox. We're working on a solution so you can use Firefox again in the future. In the meantime, please open this page in another browser, such as Chrome, Edge or Safari, or broadcast with an external encoder using RTMP or SRT.",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.SRT": "SRT device",

    "Broadcaster.AccessDenied.Title": "Unable to broadcast the webinar",
    "Broadcaster.AccessDenied": "You are not allowed to broadcast this webinar. If you think this is a mistake, please contact the OnlineWebinar.com support team.",
    "Broadcaster.NoBooking.Title": "Timeslot not available",
    "Broadcaster.NoBooking": "You cannot start the webinar because there is no booking for this webinar. Please check the webinar booking details or contact the OnlineWebinar.com support team for assistance.",
    "Broadcaster.Error.Title": "An error occurred",
    "Broadcaster.Error": "An error occurred while trying to broadcast the webinar. Please try again later or contact the OnlineWebinar.com support team.",
    "Broadcaster.NoVideoPreview": "Preview not available",
    "Broadcaster.NotActivePresenter": "Another presenter is currently broadcasting. Would you like to take over as the active presenter?",
    "Broadcaster.UnsupportedBrowser.Title": "Unsupported browser",
    "Broadcaster.UnsupportedBrowser": "Your browser is not supported for broadcasting webinars. Please use a modern browser such as Google Chrome, Mozilla Firefox, Microsoft Edge or Safari.",
    "Broadcaster.AudioAndVideoSelection.NoDevicesError": "We could not find any audio and/or video devices. Please make sure the website has permissions to access them. <br> Or check of they are in use, for example when the broadcaster is already open in another tab.",
    "Broadcaster.Button.ClaimActivePresenter": "Take over as presenter",
    "Broadcaster.Button.DesktopShare": "Desktop Sharing",
    "Broadcaster.Button.End": "End broadcast",
    "Broadcaster.Button.Pause": "Pause",
    "Broadcaster.Button.Resume": "Resume!",
    "Broadcaster.Button.Start": "Go live!",
    "Broadcaster.Button.ExtendDuration": "Extend duration by {{minutes}} minutes",
    "Broadcaster.Button.NextSlideToggle.Max": "Maximize slide preview",
    "Broadcaster.Button.NextSlideToggle.Min": "Minimize slide preview",
    "Broadcaster.Button.SwitchFullSize.ToSlides": "Switch to full-size slides",
    "Broadcaster.Button.SwitchFullSize.ToVideo": "Switch to full-size video",

    "Broadcaster.Dialog.ConnectionIssue.Button.Close": "Close and return to the broadcast",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.Text": "No video is coming in from your encoder, or the connection to the server was lost. <strong>This does not pause the webinar:</strong> viewers see and hear what your encoder sends again as soon as it reconnects.<br>Please check your encoder and your internet connection.",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.WaitingForMedia": "The connection to the server is fine, but no video is coming in from your encoder. Check that your encoder is still broadcasting.",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.TextResume": "As soon as your encoder is broadcasting again, you can close this window and carry on.",
    "Broadcaster.Dialog.ConnectionIssue.Reconnecting": "Trying to reconnect to the server.",
    "Broadcaster.Dialog.ConnectionIssue.WaitingForMedia": "The connection to the server is fine. Waiting for your video and audio to come back through; you can resume as soon as they do.",
    "Broadcaster.Dialog.ConnectionIssue.SuggestRefresh": "Refresh the page to reload the broadcast.",
    "Broadcaster.Dialog.ConnectionIssue.Text": "We lost the connection to the server due to a problem with your internet connection. <strong>The webinar has been paused.</strong><br>Please check your connection and/or close other tabs in your browser.",
    "Broadcaster.Dialog.ConnectionIssue.TextResume": "Should the connection return, you can click the Resume button below to continue with the broadcast.",
    "Broadcaster.Dialog.ConnectionIssue.Title": "Connection lost",
    "Broadcaster.Dialog.EncoderPause.Title": "Pausing an external encoder",
    "Broadcaster.Dialog.EncoderPause.Text": "This broadcast comes from your own encoder, so we cannot pause the incoming video. Your viewers keep receiving whatever your encoder sends, whatever this webinar's state says. Mute the audio and video in your encoder if you do not want to be seen or heard.",
    "Broadcaster.Dialog.MoqFallback.Title": "Switched to the classic connection",
    "Broadcaster.Dialog.MoqFallback.Text": "Media over QUIC could not connect. We are now connecting over the classic connection (WebRTC). If you were already live, resume the webinar as soon as your video is back.",
    "Broadcaster.Moq.SlowConnect.Text": "Connecting over Media over QUIC is taking longer than expected…",
    "Broadcaster.Moq.SlowConnect.Button": "Switch to the classic connection (WebRTC) now",
    "Broadcaster.Dialog.EndWebinar.Button.Confirm": "Yes, end broadcast",
    "Broadcaster.Dialog.EndWebinar.Text": "Are you sure you want to end this broadcast?",
    "Broadcaster.Dialog.EndWebinar.Title": "End broadcast",
    "Broadcaster.Dialog.TooEarly.Title": "Oops, you are a bit too early!",
    "Broadcaster.Dialog.TooEarly.Text": "We noticed that you want to start your webinar a bit earlier than the scheduled starting time. Are you sure you want to do this?",
    "Broadcaster.Dialog.TooEarly.CountdownText": "Countdown to scheduled starting time:",
    "Broadcaster.Dialog.TooEarly.OnlineViewersTitle": "Number of viewers already online:",
    "Broadcaster.Dialog.TooEarly.OnlineViewersText": "online",

    "Broadcaster.Message.Ended": "This webinar has ended <span>on</span> {{date}} <span>at</span> {{time}}",
    "Broadcaster.Poll.Button.Start": "Start poll",
    "Broadcaster.Poll.Button.Close": "Close poll",
    "Broadcaster.Poll.Button.HideResults": "Hide results",
    "Broadcaster.Poll.NoPublicResults": "The results of this poll are not publicly visible.",
    "Broadcaster.Poll.WeightingApplied": "Weighting factor applied",
    "Broadcaster.RemainingTimePanel.Ending": "The webinar will end in",
    "Broadcaster.RemainingTimePanel.ExtensionFailed": "The webinar end time could not be extended",
    "Broadcaster.RemainingTimePanel.ExtensionNotAvailable": "The webinar end time can not be extended anymore",
    "Broadcaster.RemainingTimePanel.ExtensionSuccess": "The webinar end time is successfully extended",

    "Broadcaster.Status.Broadcasting": "Broadcasting",
    "Broadcaster.Status.GoLiveIn": "Go live in",
    "Broadcaster.Status.GoLiveNow": "Go live now",
    "Broadcaster.Status.Ended": "Ended",
    "Broadcaster.Status.Camera": "Camera is selected",
    "Broadcaster.Status.Camera.Issue": "No suitable camera selected",
    "Broadcaster.Status.Heading": "Status",
    "Broadcaster.Status.Mic": "Microphone is selected",
    "Broadcaster.Status.Mic.Issue": "No Microphone selected",
    "Broadcaster.Status.PossibleSolution": "Possible solution:",
    "Broadcaster.Status.Recorder.Issue": "Your webinar is not being recorded",
    "Broadcaster.Status.Recorder": "Your webinar is being recorded",
    "Broadcaster.Status.Encoder": "Your encoder settings are correct",
    "Broadcaster.Status.Encoder.Issue.Audio": "Your encoder is sending surround audio",
    "Broadcaster.Status.Encoder.Issue.Level": "Your encoder uses a video setting some devices refuse",
    "Broadcaster.Status.Encoder.Issue.Unknown": "We could not check your encoder yet",
    "Broadcaster.Status.Solution.Encoder.Audio": "Set your encoder to stereo (2 channels) and connect again. Until you do, viewers using Firefox hear nothing, and you won't be able to go live.",
    "Broadcaster.Status.Solution.Encoder.Level": "Set the H.264 level in your encoder to 4.2, or to automatic, and connect again. Until you do, some iPhones, iPads and televisions refuse the stream, and you won't be able to go live.",
    "Broadcaster.Status.Encoder.Issue.AudioAndLevel": "Your encoder has two settings that need changing",
    "Broadcaster.Status.Solution.Encoder.AudioAndLevel": "Set your encoder to stereo (2 channels) and set the H.264 level to 4.2, or to automatic. Then connect again. Until you do, viewers using Firefox hear nothing, some iPhones, iPads and televisions refuse the stream, and you won't be able to go live.",
    "Broadcaster.Status.Solution.Encoder.Unknown": "If you have just connected your encoder, wait a few seconds. If this message stays, check that your encoder is streaming.",
    "Broadcaster.Status.Server": "Connected to the server",
    "Broadcaster.Status.Server.Issue": "No connection to the server",
    "Broadcaster.Status.Solution.Initializing": "The connection is initializing, please wait",
    "Broadcaster.Status.Solution.Refresh": "Refresh your browser",
    "Broadcaster.Status.Solution.WaitForTimeslot": "Wait for your timeslot to become available",
    "Broadcaster.Status.Solution.Button.Reconnect": "Click here to reconnect",
    "Broadcaster.Status.Troubleshoot.Button": "Troubleshoot",
    "Broadcaster.Status.Troubleshoot.Text": "If the problems persist, click the button below to go to a troubleshooting page with most common problems and solutions:",
    "Broadcaster.Status.VideoServer": "Connected to the video server",
    "Broadcaster.Status.VideoServer.Issue": "No connection to the video server",
    "Broadcaster.Status.VideoServer.Optimal": "Optimal connection to the video server",
    "Broadcaster.Status.VideoServer.Score": "Current connection score:",
    "Broadcaster.Status.VideoServer.Score.Audio": "Audio score is <strong>{{audioScore}}</strong> of <strong>10</strong>",
    "Broadcaster.Status.VideoServer.Score.Video": "Video score is <strong>{{videoScore}}</strong> of <strong>10</strong>",
    "Broadcaster.Status.VideoServer.Score.Text": "Your internet connection or computer may not be fast enough to broadcast a webinar. If you are using a wireless connection, try switching to a wired connection.",
    "Broadcaster.Status.VideoServer.Unstable": "Connection with the video server is unstable",
    "Broadcaster.Status.ServerActions.Issue": "The server is having trouble processing some of your actions",

    "Chat.Button.ChatPaused.FollowChat": "See latest message",
    "Chat.Button.ChatPaused.Paused": "Chat paused due to scroll",
    "Chat.ChannelName.All": "All",
    "Chat.ChannelName.Public": "Public",
    "Chat.ChannelName.Moderator": "Moderators",
    "Chat.ChannelName.Presenter": "Presenter",
    "Chat.ChannelName.Speakers": "Speakers",
    "Chat.ChannelName.Unknown": "Unknown",
    "Chat.Channel.Button.Close": "Close private chat channel with {{channelName}}",
    "Chat.Channel.Button.CloseAndMarkUnread": "Close private chat channel with {{channelName}}, and mark messages as unread",
    "Chat.Message.Button.CancelForward": "Cancel forward message",
    "Chat.Message.Deleted": "This message was deleted",
    "Chat.Message.ForwardedFrom": "Forwarded from ",
    "Chat.Message.ReplyingTo": "Replying to ",
    "Chat.MessageInput.CharactersRemaining": "{{characterAmount}} characters left",
    "Chat.OnDemand.InfoText": "Your chat messages are forwarded. You will receive a response from us within 48 hours.",
    "Chat.Option.Delete": "Delete message",
    "Chat.Option.ForwardToPresenter": "Forward to the presenter chat",
    "Chat.Option.ForwardToModerator": "Forward to moderator chat",
    "Chat.Option.ForwardToPublic": "Forward to public chat",
    "Chat.Option.OriginalForwardToModerator": "Forward orignal message to moderator chat",
    "Chat.Option.OriginalForwardToPresenter": "Forward orignal message to presenter chat",
    "Chat.Option.OriginalForwardToPublic": "Forward orignal message to public chat",
    "Chat.Option.ReplyPrivately": "Reply privately",
    "Chat.OnDemandChat.Nickname": "System message",
    "Chat.OnDemandChat.Message": "Your chat messages have been forwarded to the presenter.",

    "ChatSettings.OnDemandChat.Label.Email": "Forward to e-mail address",
    "ChatSettings.OnDemandChat.Switch.Label": "Enable on demand chat",
    "ChatSettings.PageHeading": "Chat settings",

    "Chat.Standard.Header": "Standard messages",
    "Chat.Standard.Message1": "",
    "Chat.Standard.Message2": "",
    "Chat.Standard.Message3": "",
    "Chat.Standard.Message4": "",
    "Chat.Standard.Message5": "",
    "Chat.Standard.Message6": "",
    "Chat.Standard.Message7": "",
    "Chat.Standard.Message8": "",
    "Chat.Standard.Message9": "",
    "Chat.Standard.NoMessages": "No standard messages have been defined yet.",

    "CompositePageHeader.Label.Date": "date:",
    "CompositePageHeader.Label.Event": "webinar:",

    "ContactList.Button.Export": "Export list",
    "ContactList.Table.Header.Date": "Date",
    "ContactList.Table.Header.FirstOnline": "First online",
    "ContactList.Table.Header.TimeOnline": "Time online",
    "ContactList.Table.Header.PercentageOnline": "%",

    "Content.Attachments.Button.Delete": "Delete attachment {{file}}",
    "Content.Attachments.Button.Edit": "Edit attachment {{file}}",
    "Content.Attachments.Dialog.Heading": "Edit attachment",
    "Content.Attachments.Dialog.Label.AttachmentTitle": "Name of the attachment",
    "Content.Attachments.Dialog.Label.AttachmentVisibility": "Visibility of the attachment",
    "Content.Attachments.DragDrop.AcceptedFileTypes": "PDF",
    "Content.Attachments.Heading.MultipleAttachments": "{{amount}} attachments",
    "Content.Attachments.Heading.OneAttachment": "1 attachment",
    "Content.Attachments.Table.Header.Visibility": "Visibility",
    "Content.Attachments.Table.Header.Title": "Title",
    "Content.Attachments.Table.Header.Type": "Type",
    "Content.Attachments.PageHeading": "Attachments",
    "Content.Attachments.Progress.Label": "Uploading document:",
    "Content.Attachments.Type.File": "File",
    "Content.Attachments.Visibility.Authenticated": "Authenticated",
    "Content.Attachments.Visibility.Private": "Private",
    "Content.Attachments.Visibility.Public": "Public",

    "Content.Chapters.Button.AddChapter": "Add chapter",
    "Content.Chapters.Button.DeleteChapter": "Delete chapter {{chapter}}",
    "Content.Chapters.ChapterTitleHeader": "Title of the chapter",
    "Content.Chapters.ConfirmDelete.Title": "Delete chapter",
    "Content.Chapters.ConfirmDelete.Msg": "Are you sure you want to delete chapter <strong>{{chapter}}</strong>?",
    "Content.Chapters.PageHeading": "Chapters",
    "Content.Chapters.SlideNumberHeader": "Starts with slide",
    "Content.Chapters.ReadOnly": "This webinar has already been broadcasted. You can edit the chapters in the on-demand editor.",

    "Content.Overview.Button.Edit": "Edit",
    "Content.Overview.Button.Share": "Share",
    "Content.Overview.Button.Broadcast": "Broadcast",
    "Content.Overview.Button.Publish": "Publish",
    "Content.Overview.Button.Unpublish": "Unpublish",
    "Content.Overview.Exam.Active": "Exam active",
    "Content.Overview.Exam.Inactive": "Exam inactive",
    "Content.Overview.Exam.NotValid": "Exam not valid",
    "Content.Overview.Images.Info": "The profile image should have a minimum size of 120 x 120 pixels. The banner image should have a minimum size of 896 x 224 pixels. You can use images with different aspect ratios, they will be cropped around the center.",
    "Content.Overview.Images.Label": "Webinar profile and banner image",
    "Content.Overview.Security.Active": "Security active",
    "Content.Overview.Security.Inactive": "Security inactive",
    "Content.Overview.Survey.Active": "Survey active",
    "Content.Overview.Survey.Inactive": "Survey inactive",
    "Content.Overview.Survey.NotValid": "Survey not valid",

    "Content.Poll.AddPoll": "Add a poll",
    "Content.Poll.AnswerHeader": "Answers",
    "Content.Poll.PointsHeader": "Points (optional)",
    "Content.Poll.Button.DeletePollAnswer": "Delete poll answer",
    "Content.Poll.Button.DeletePoll": "Delete poll",
    "Content.Poll.Button.DeletePollAriaLabel": "Delete poll {{poll}}",
    "Content.Poll.ConfirmDelete.Title": "Delete poll",
    "Content.Poll.ConfirmDelete.Msg": "Are you sure you want to delete <strong>{{poll}}</strong>?",
    "Content.Poll.Link.WeightinFactor": "Weighting factor list",
    "Content.Poll.Option.ApplyWeighting": "Apply weighting factor to this poll",
    "Content.Poll.Option.PublicResults": "Show poll results to the viewers",
    "Content.Poll.Option.ShowPercentagesOnly": "Only show percentages in the poll results",
    "Content.Poll.Option.ShowPercentagesOnly.DisabledReason": "Only applies when poll results are shown to the viewers",
    "Content.Poll.PageHeading": "Polls",
    "Content.Poll.PollItemHeader": "What would you like to ask your audience?",
    "Content.Poll.QuestionLabel": "Your question",
    "Content.Poll.OptionLabel": "Answer {{index}}{{char}}",
    "Content.Poll.OptionPlaceholder": "Answer",
    "Content.Poll.PointsLabel": "Points for answer {{index}}{{char}} (optional)",
    "Content.Poll.PointsPlaceholder": "Points",
    "Content.Poll.UpdateOnlyWarning": "This webinar has already been broadcasted. Only the poll weighting factor and points can be updated.",

    "Content.PollWeighting.Button.ClearList": "Clear list",
    "Content.PollWeighting.DragDrop.AcceptedFileTypes": ".xls, .xlsx and .csv",
    "Content.PollWeighting.Input.DefaultWeight": "Default weight factor",
    "Content.PollWeighting.Heading.DefaultWeight": "Default weight factor",
    "Content.PollWeighting.Text.DefaultWeight": "The default weight factor is used when no weight factor is available for a participant. Set the default weighting factor to 0 if you do not want to apply a weighting factor to the participants who are not in the weighting factor list.",
    "Content.PollWeighting.Heading.ImportList": "Import list",
    "Content.PollWeighting.Text.ImportList": "Import an Excel document with two columns: one for the e-mailaddress and one for the weight factor (number). This weight factor will then be used for calculating the results of the poll. <strong>The document should not contain any titles or headers.</strong>",
    "Content.PollWeighting.NoWeights": "No weight factors have been added yet.",
    "Content.PollWeighting.Heading.List": "Weight factor list",
    "Content.PollWeighting.PageHeading": "Poll weighting",
    "Content.PollWeighting.Table.Heading.Email": "E-mailaddress",
    "Content.PollWeighting.Table.Heading.Factor": "Weight factor",
    "Content.PollWeighting.Table.Button.DeleteEntry": "Remove {{email}} from the weight factor list",

    "Content.Slides.ConfirmDelete.Title": "Delete Slide",
    "Content.Slides.ConfirmDelete.Msg": "Are you sure you want to delete the current slide deck?",
    "Content.Slides.FileLabel": "File",
    "Content.Slides.PageHeading": "Slides",
    "Content.Slides.PreviewHeading": "Preview",
    "Content.Slides.SlidesAmountLabel": "No of slides",
    "Content.Slides.Status.Error": "Your slide deck is being processed",
    "Content.Slides.Status.Processing": "Your slide deck is being processed",
    "Content.Slides.Status.Queued": "Your slide deck has been queued for processing",
    "Content.Slides.Status.Success": "File uploaded successfully",
    "Content.Slides.Restrictions": "<bold>PDF</bold>",
    "Content.Slides.ReadOnly": "This webinar has already been broadcasted. You can edit the slides in the on-demand editor.",

    "Dashboard.Heading.Upcoming": "Upcoming webinars",
    "Dashboard.Heading.UpNext": "Up next",
    "Dashboard.Link.AllEvents": "Show all webinars",
    "Dashboard.PageHeading": "Dashboard",

    "DefaultSurvey.Title": "Survey",
    "DefaultSurvey.Intro": "Would you please fill out the survey?",
    "DefaultSurvey.Outro": "Thank you for completing the survey.",
    "DefaultSurvey.Question.OverallRating": "What is your overall rating of this webinar on a scale of 1 (very poor) to 10 (excellent)?",
    "DefaultSurvey.Question.SpeakerRating": "What is your judgment of the speaker(s) on a scale of 1 (very poor) to 10 (excellent)?",
    "DefaultSurvey.Question.ContentRating": "What did you think of the content of the webinar on a scale of 1 (very poor) to 10 (excellent)?",
    "DefaultSurvey.Question.QuestionRating": "If you had a question, were they answered satisfactorily?",
    "DefaultSurvey.Question.WouldRecommend": "Would you like to participate in future webinars?",
    "DefaultSurvey.Question.OpenQuestion": "If you have any questions or comments, you can mention them here.",
    "DefaultSurvey.Answer.Yes": "Yes",
    "DefaultSurvey.Answer.No": "No",
    "DefaultSurvey.Answer.Other": "Other",

    "EditExam.Info.ZeroMeansUnlimitedRetries": "Enter the amount of times the participant can retake the exam. If 0 (zero) is entered, this means that the exam can be retaken an infinite number of times.",
    "EditExam.Heading.Failed": "Exam failed text",
    "EditExam.Heading.Intro": "Introduction text",
    "EditExam.Heading.Outro": "Thank you text",
    "EditExam.Heading.Passed": "Exam passed text",
    "EditExam.Heading.Questions": "Questions",
    "EditExam.Heading.Settings": "Settings",
    "EditExam.Label.AllowRetries": "Allow the participant to retake the exam",
    "EditExam.Label.Enable": "Enable exam",
    "EditExam.Label.Failed": "Exam failed text",
    "EditExam.Label.Intro": "Introduction text",
    "EditExam.Label.MaximumRetries": "The amount of retakes",
    "EditExam.Label.Outro": "Thank you text",
    "EditExam.Label.Passed": "Exam passed text",
    "EditExam.Label.PassingScore": "The score to pass the exam",
    "EditExam.Label.Required": "The exam is required",
    "EditExam.Label.ShowResult": "Show the result of the exam to the participant",
    "EditExam.Label.ShowWrongAnswers": "Show which questions the participant answered incorrectly",
    "EditExam.Label.Title": "Title of the exam",
    "EditExam.NoQuestions": "The exam contains no questions",
    "EditExam.Pageheading": "Exam",
    "EditExam.Save.Saved": "Save succesfull",
    "EditExam.Save.Saving": "Saving your changes",
    "EditExam.Save.Error": "Error saving the exam",
    "EditExam.Tab.Failed": "Failed",
    "EditExam.Tab.Intro": "Intro",
    "EditExam.Tab.Outro": "Outro",
    "EditExam.Tab.Passed": "Passed",
    "EditExam.Tab.Questions": "Questions",
    "EditExam.Tab.Settings": "Settings",
    "EditExam.Validation.FailedRequired": "'Exam failed' text is required",
    "EditExam.Validation.IntroRequired": "Introduction text is required",
    "EditExam.Validation.OutroRequired": "Thank you text is required",
    "EditExam.Validation.PassedRequired": "'Exam passed' text is required",
    "EditExam.Validation.QuestionsRequired": "Questions are required",
    "EditExam.Validation.TitleRequired": "A title for the exam is required",

    "EditFollowUp.Heading.EmailTemplate": "Follow-up e-mail template",
    "EditFollowUp.Label.BccOwner": "Add the organizer as BCC",
    "EditFollowUp.Label.MinimumExamAnswers": "Minimum number of exam questions answered",
    "EditFollowUp.Label.MinimumExamPoints": "Minimum number of exam points",
    "EditFollowUp.Label.MinimumOnlinePercentage": "Minimum percentage watched",
    "EditFollowUp.Label.MinimumPollPoints": "Minimum number of poll points",
    "EditFollowUp.Label.MinimumPollVotes": "Minimum number of poll votes",
    "EditFollowUp.Label.MinimumSurveyAnswers": "Minimum number of survey answers",
    "EditFollowUp.Label.Name": "Name",
    "EditFollowUp.PageHeading": "Edit follow-up e-mail",
    "EditFollowUp.Toast.Error": "There was an error. The follow-up has not been saved.",
    "EditFollowUp.Toast.Saved": "Follow-up saved",
    "EditFollowUp.Toast.Saving": "Saving follow-up",

    "EditQuestionnaire.Button.AddMultipleChoiceQuestion": "Multiple choice question",
    "EditQuestionnaire.Button.AddSingleChoiceQuestion": "Single choice question",
    "EditQuestionnaire.Button.AddOpenQuestion": "Open question",
    "EditQuestionnaire.Button.AddOption": "Add an answer",
    "EditQuestionnaire.Button.DeleteQuestion": "Delete question",
    "EditQuestionnaire.Button.EditQuestion": "Edit question",
    "EditQuestionnaire.Button.MoveDown": "Move answer down",
    "EditQuestionnaire.Button.MoveUp": "Move answer up",
    "EditQuestionnaire.Button.QuestionSortDown": "Move question down",
    "EditQuestionnaire.Button.QuestionSortUp": "Move question up",
    "EditQuestionnaire.Button.RemoveOption": "Remove this answer",
    "EditQuestionnaire.Heading.MultipleChoiceQuestion": "Multiple choice question",
    "EditQuestionnaire.Heading.Options": "Answers",
    "EditQuestionnaire.Heading.OpenQuestion": "Open question",
    "EditQuestionnaire.Heading.SingleChoiceQuestion": "Single choice question",
    "EditQuestionnaire.Label.HasOtherOption": "Include 'other' option",
    "EditQuestionnaire.Label.Option": "Answer {{number}}",
    "EditQuestionnaire.Label.OptionValue": "Value",
    "EditQuestionnaire.Label.OtherOptionText": "'Other' option text",
    "EditQuestionnaire.Label.Question": "Question",
    "EditQuestionnaire.Label.RequiredQuestion": "This question is required",
    "EditQuestionnaire.QuestionDetail.Options": "Answers:",
    "EditQuestionnaire.QuestionDetail.OtherOptionText": ", including other option",
    "EditQuestionnaire.QuestionDetail.Question": "Question:",
    "EditQuestionnaire.QuestionDetail.Required": "Required:",
    "EditQuestionnaire.Validation.OptionTextRequired": "Answer {{option}} of question number {{question}} is missing text",
    "EditQuestionnaire.Validation.OptionValueRequired": "Answer {{option}} of question number {{question}} does not have a valid value",
    "EditQuestionnaire.Validation.OptionsRequired": "Missing answers on question number {{question}}",
    "EditQuestionnaire.Validation.OtherOptionTextRequired": "Missing other option text on question number {{question}}",
    "EditQuestionnaire.Validation.QuestionRequired": "Missing question text on question number {{question}}",

    "EditSubtitles.Button.Delete": "Delete subtitles {{name}}",
    "EditSubtitles.Button.Download": "Download subtitles {{name}}",
    "EditSubtitles.Button.GenerateSubtitles": "Generate subtitles",
    "EditSubtitles.Button.GeneratorSubtitles": "Start subtitle generator",
    "EditSubtitles.DragDrop.AcceptedFileTypes": ".srt and .vtt",
    "EditSubtitles.GenerateSubtitlesOptions.DeepgramSettings": "Deepgram settings",
    "EditSubtitles.GenerateSubtitlesOptions.Title": "Generate subtitles",
    "EditSubtitles.GeneratorSubtitles.InfoText": "If your ondemand has no subtitles, you can automatically generate them. In case there are subtitles that were generated during the live webinar, it might be beneficial to re-generate them because the translation will be more acurate.",
    "EditSubtitles.GeneratorStatus.Generating": "Generating subtitles",
    "EditSubtitles.PageHeading": "Edit subtitles",
    "EditSubtitles.TableHeader.Default": "Default",
    "EditSubtitles.TableHeader.Enabled": "Enabled",
    "EditSubtitles.TableHeader.TrackId": "Track ID",

    "EditSurvey.Heading.Intro": "Introduction text",
    "EditSurvey.Heading.Outro": "Thank you text",
    "EditSurvey.Heading.Questions": "Questions",
    "EditSurvey.Label.Enabled": "Enable survey",
    "EditSurvey.Label.Intro": "Introduction text",
    "EditSurvey.Label.Outro": "Thank you text",
    "EditSurvey.Label.Required": "The survey is required",
    "EditSurvey.Label.Title": "Title of the survey",
    "EditSurvey.NoQuestions": "The survey contains no questions",
    "EditSurvey.Pageheading": "Survey",
    "EditSurvey.Save.Saved": "Save succesfull",
    "EditSurvey.Save.Saving": "Saving your changes",
    "EditSurvey.Save.Error": "Error saving the survey",
    "EditSurvey.Tab.Intro": "Intro",
    "EditSurvey.Tab.Outro": "Outro",
    "EditSurvey.Tab.Questions": "Questions",
    "EditSurvey.Validation.IntroRequired": "Introduction text is required",
    "EditSurvey.Validation.OutroRequired": "Thank you text is required",
    "EditSurvey.Validation.QuestionsRequired": "Questions are required",
    "EditSurvey.Validation.TitleRequired": "Title is required",

    "Editor.Button.Save": "Save",
    "Editor.Button.SaveOndemand": "Save on demand",
    "Editor.Button.MoveToIndicator": "Move to indicator",
    "Editor.Chapter.Button.Add": "Add new chapter",
    "Editor.Chapter.Button.Delete": "Delete chapter",
    "Editor.Chapter.Heading": "Edit chapter",
    "Editor.Chapter.New": "Chapter",
    "Editor.Chapter.Title.Label": "Chapter title",
    "Editor.Chat.Button.Add": "Add new chat message",
    "Editor.Chat.Button.Delete": "Delete chat message",
    "Editor.Chat.Message.Label": "Chat message text",
    "Editor.Chat.Heading": "Edit chat message",
    "Editor.Download.Video.Button": "Download MP4 video",
    "Editor.Download.Video.Heading": "Download orginal video",
    "Editor.Download.Video.Text": "You can download the original video as an MP4 file. Trims made using the editor will not have been applied to this video.",
    "Editor.PageHeading": "Editor",
    "Editor.Publishing.Modal.Close": "Close this message",
    "Editor.Publishing.Modal.Error": "There was an error saving your changes.",
    "Editor.Publishing.Modal.Success": "Your changes have been saved successfully!",
    "Editor.Publishing.Modal.Progress.Label": "Publish progress:",
    "Editor.Publishing.Modal.Publishing": "Saving your changes",
    "Editor.Publishing.Modal.PublishingHeader": "Publishing changes",
    "Editor.Publishing.Modal.PublishingDescription": "After the changes have been saved, they will be visible in the on demand.",
    "Editor.Publishing.Modal.KeyframeExtraction": "Extracting",
    "Editor.Publishing.Modal.KeyframeExtractionHeader": "Extracting keyframes",
    "Editor.Publishing.Modal.KeyframeExtractionDescription": "Keyframes are being extracted from the video. This may take a while depending on the length of the video.",
    "Editor.Publishing.Modal.Encoding": "Reencoding",
    "Editor.Publishing.Modal.EncodingHeader": "Reencoding video",
    "Editor.Publishing.Modal.EncodingDescription": "The video is being reencoded with the applied changes. This may take a while depending on the length of the video.",
    "Editor.Publishing.Modal.GetDurationStep": "Getting video duration",
    "Editor.Publishing.Modal.EncodeStep": "Reencoding video",
    "Editor.Publishing.Modal.CreateHlsStep": "Creating HLS video",
    "Editor.Publishing.Modal.KeyframeExtractionStep": "Extracting keyframes",
    "Editor.Publishing.Modal.CleanupStep": "Cleaning up",
    "Editor.Poll.Button.Delete": "Delete poll",
    "Editor.Poll.Button.Next": "Next poll",
    "Editor.Poll.Button.Previous": "Previous poll",
    "Editor.Poll.Heading": "Edit poll",
    "Editor.SaveInfoText": "Changes that have been made in the editor will be visible in the on demand after pressing 'Save on demand'.",
    "Editor.Slides.Button.Add": "Add new slide",
    "Editor.Slides.Button.Delete": "Delete slide",
    "Editor.Slides.Button.Replace": "Replace slide",
    "Editor.Slides.Heading": "Edit slide",
    "Editor.Timeline.Zoom.Text": "Timeline zoom:",
    "Editor.Timestamp.Legend": "Start time",
    "Editor.Trackname.Chapters": "Chapters",
    "Editor.Trackname.Chat": "Chat",
    "Editor.Trackname.Polls": "Polls",
    "Editor.Trackname.Slides": "Slides",
    "Editor.Trackname.VideoLayout": "Video layout",
    "Editor.TrimVideo.Button.Delete": "Remove video trim",
    "Editor.TrimVideo.Heading": "Trim video",
    "Editor.TrimVideo.TrimNumber": "Trim {{number}}",
    "Editor.Upload.Button": "Upload video",
    "Editor.Upload.Button.Cancel": "Cancel upload",
    "Editor.Upload.Button.Pause": "Pause upload",
    "Editor.Upload.Button.Resume": "Resume upload",
    "Editor.Upload.DragDrop.AcceptedFileTypes": ".3g2, .3gp, .avi, .flv, .h264, .mkv, .mov, .mp4, .mpeg, .mpg, .qt, .webm and .wmv",
    "Editor.Upload.Heading": "Upload video",
    "Editor.Upload.Paused": "Video upload is paused.",
    "Editor.Upload.Progress.Label": "Uploading video",
    "Editor.VideoBeingAnalyzed": "Please wait, video is being analyzed",
    "Editor.VideoLayout.Heading": "Edit video layout",
    "Editor.VideoLayout.Item.Classic": "Classic",
    "Editor.VideoLayout.Item.Default": "Default",
    "Editor.VideoLayout.Item.DesktopSharing": "Desktop share",
    "Editor.VideoLayout.Item.PresentationWithVideoLarge": "Video with small slides",
    "Editor.VideoLayout.Item.PresentationWithVideoSmall": "Slides with small video",
    "Editor.VideoLayout.Item.UnknownLayout": "Unknown video layout",
    "Editor.VideoLayout.Item.VideoOnly": "Video only",

    "Email.Preview.Heading": "Preview",
    "Email.Preview.Updating": "Updating preview",
    "Email.Style.Error.InvalidStyle": "Invalid style",
    "Email.Style.HeaderImage.AcceptedTypes": "JPG, PNG, GIF and WebP",
    "Email.Style.HeaderImage.AltTextInfo": "Describe the image if it carries information, such as a logo with text. Leave empty for a purely decorative image.",
    "Email.Style.HeaderImage.Button.UseDefault": "Use default image",
    "Email.Style.HeaderImage.CurrentImageAlt": "Current e-mail header image",
    "Email.Style.HeaderImage.FileLimits": "Up to 10 MB. An animated GIF keeps only its first frame.",
    "Email.Style.HeaderImage.Heading": "Header image",
    "Email.Style.HeaderImage.Info": "The image is cropped around the center to 580 × 160 pixels and saved as JPG or PNG, whichever is smaller. A new image only applies to e-mails sent from now on.",
    "Email.Style.HeaderImage.Label.AltText": "Alternative text for the header image",
    "Email.Style.HeaderImage.Warning.NoPlaceholder": "The template below does not contain @HeaderImageUrl, so the header image will not appear in the e-mails. Use src=\"@HeaderImageUrl\" alt=\"@HeaderImageAlt\" on the header image.",
    "Email.Style.HeaderImage.Warning.TooSmall": "This image is smaller than 580 × 160 pixels. It is enlarged and may look blurry.",
    "Email.Style.Label.Button": "Button style",
    "Email.Style.Label.Code": "Code style",
    "Email.Style.Label.Heading": "Heading {{level}} style",
    "Email.Style.Label.Paragraph": "Paragraph style",
    "Email.Style.Label.Template": "Template",
    "Email.Style.PageHeading": "E-mail template style",
    "Email.Style.Warning": "Note: the template and styles will be sanitized to avoid XSS attacks, check if the styles are still correct after saving.",
    "Email.Template.Label.Body": "Body",
    "Email.Template.Label.IncludeCalendarAttachment": "Include calendar attachment (.ics)",
    "Email.Template.Label.SelectTemplate": "Select e-mail template",
    "Email.Template.Label.Subject": "Subject",
    "Email.Template.PageHeading": "E-mail template",

    "EmailStatus.Failed": "Failed",
    "EmailStatus.Queued": "Queued",
    "EmailStatus.Sending": "Sending",
    "EmailStatus.Sent": "Sent",

    "FollowUpOverview.Button.CreateFollowUp": "Create follow-up",
    "FollowUpOverview.Button.Delete": "Delete follow-up {{name}}",
    "FollowUpOverview.Button.Edit": "Edit follow-up {{name}}",
    "FollowUpOverview.InfoText": "Here you can define one or more follow-up e-mails. A follow-up e-mail will be sent when certain conditions are met. For example when a participant has watched the entire webinar, or when they have passed an exam.",
    "FollowUpOverview.NoFollowUps": "There is no follow-up e-mail active for this webinar.",
    "FollowUpOverview.PageHeading": "Follow-up e-mail",
    "FollowUpOverview.TableHeader.BccOwner": "BCC organiser",
    "FollowUpOverview.TableHeader.Name": "Name",
    "FollowUpOverview.TableHeader.Processed": "Sent",

    "Footer.Link.CookiePolicy": "Cookie Policy",
    "Footer.Link.PrivacyPolicy": "Privacy Policy",
    "Footer.Link.Support": "Support",
    "Footer.Link.TermsOfUse": "Terms and Conditions",

    "Generic.ApiErrorCode.Exception": "Something went wrong",
    "Generic.ApiErrorCode.Exception.Body": "Something went wrong, please refresh the page or try again later.",
    "Generic.ApiErrorCode.NotFoundException": "Not found",
    "Generic.ApiErrorCode.NotFoundException.Body": "The page that you are looking for no longer exists.",
    "Generic.ApiErrorCode.NotPublishedException": "Not published",
    "Generic.ApiErrorCode.NotPublishedException.Body": "The webinar that you are looking for is currently not published.",
    "Generic.ApiErrorCode.CancelledException": "Cancelled",
    "Generic.ApiErrorCode.CancelledException.Body": "The webinar that you are looking for has been cancelled.",
    "Generic.ApiErrorCode.ExpiredException": "Expired",
    "Generic.ApiErrorCode.ExpiredException.Body": "The webinar that you are looking for has expired.",
    "Generic.ApiErrorCode.AccessDeniedException": "Access denied",
    "Generic.ApiErrorCode.AccessDeniedException.Body": "You do not have access to this page.",
    "Generic.ApiErrorCode.AccountNotVerifiedException": "Account not verified",
    "Generic.ApiErrorCode.AccountNotVerifiedException.Body": "This functionality is only available for verified accounts.",
    "Generic.ApiErrorCode.ServiceUnavailableException": "Temporarily unavailable",
    "Generic.ApiErrorCode.ServiceUnavailableException.Body": "The platform is undergoing maintenance. Please try again in a few minutes.",

    "Generic.Button.AriaLabel.isLoading": "Processing",
    "Generic.Loading": "Loading",
    "Generic.Button.Back": "Go back",
    "Generic.Button.Cancel": "Cancel",
    "Generic.Button.Continue": "Continue",
    "Generic.Button.Delete": "Delete",
    "Generic.Button.Details": "Details",
    "Generic.Button.Export": "Export",
    "Generic.Button.Save": "Save",
    "Generic.Button.SaveChanges": "Save changes",
    "Generic.Button.TryAgain": "Try again",
    "Generic.Button.UploadImage": "Upload image",
    "Generic.Button.Watch": "Watch",

    "Generic.Dialog.Button.Close": "Close",
    "Generic.DragDrop": "Drag & Drop",
    "Generic.DragDrop.AcceptedImageTypes": "JPG, PNG and WEBP",
    "Generic.DragDrop.AcceptedText": "The following files are accepted: ",
    "Generic.DragDrop.Active": "Drop the files here ...",
    "Generic.DragDrop.BrowseFiles": "or <span>browse</span> your files",
    "Generic.FileRejection.FileInvalidType": "This file type is not supported here.",
    "Generic.FileRejection.FileTooLarge": "This file is too large.",
    "Generic.FileRejection.FileTooSmall": "This file is too small.",
    "Generic.FileRejection.TooManyFiles": "You can only add one file at a time here.",
    "Generic.FileRejection.Unknown": "This file cannot be used here.",
    "Generic.Link.Context": ": {{title}}",
    "Generic.Link.Logo": "{{site}} - {{page}}",
    "Generic.Link.OpensInNewTab": "(opens in a new tab)",
    "Generic.Link.ViewDetails": "View details",
    "Generic.Link.WebinarSchedule": "Webinar schedule",
    "Generic.And": "and",
    "Generic.Days": "days",
    "Generic.Hour": "hours",
    "Generic.Hour.Full": "Hours",
    "Generic.Minute": "min",
    "Generic.Minute.Full": "Minutes",
    "Generic.Second": "sec",
    "Generic.Second.Full": "Seconds",
    "Generic.Interested": "Interested",
    "Generic.NotInterested": "Not interested",
    "Generic.Skiplink": "Skip to main content",

    "Image.AltText": "Alt text",
    "Image.AltText.Explanation": "Describe what the image shows or means, such as the text in it. Leave this empty if the image is only decorative. At most 250 characters.",
    "ImportInvites.Button.Import": "Import participants",
    "ImportInvites.Dialog.Progress": "Importing {{current}} of {{total}}",
    "ImportInvites.Dialog.Title": "Importing participants",
    "ImportInvites.DragDrop.AcceptedFileTypes": ".xls, .xlsx, .csv, .ods, .fods and .txt",
    "ImportInvites.ErrorMessage.WorkBookError": "At least email address is required to be imported",
    "ImportInvites.Label.HasHeader": "Document has a header",
    "ImportInvites.Label.Worksheet": "Choose a worksheet",
    "ImportInvites.MapOption.NotImported": "Not imported",
    "ImportInvites.PageHeading": "Import participants",
    "ImportInvites.Text.HasHeader": "If your document contains headers, please select the option below:",
    "ImportInvites.Text.NoDataRows": "No data rows were found in this file. If your file does not have a header row, turn off \"Document has a header\" above.",
    "ImportInvites.Text.MapColumns": "Please select a property from the list for each column of the table, so we can correctly import your data.",
    "ImportInvites.Text.MultipleWorksheets": "Your document includes multiple worksheets. Select which worksheet you would like to import:",

    "Insights.Chat.AmountText": "Number of chat messages:",
    "Insights.Chat.Button.Export": "Export chat messages",
    "Insights.Chat.PageHeading": "Chat messages",
    "Insights.Exam.AmountText": "Number of exam questions asked:",
    "Insights.Exam.PageHeading": "Exam results",
    "Insights.Exam.Button.Export": "Export exam results",
    "Insights.Exam.Label.Result": "Result",
    "Insights.Exam.Label.Score": "Score",
    "Insights.Exam.Result.Failed": "Failed",
    "Insights.Exam.Result.Passed": "Passed",
    "Insights.Exam.Select.Combined": "Combined exam results",
    "Insights.Exam.Select.Label": "Show exam results",
    "Insights.Exam.Select.Live": "Live exam results",
    "Insights.Exam.Select.OnDemand": "On demand exam results",
    "Insights.Exam.Tab.ParticipantDetails": "Participant details",
    "Insights.Exam.Tab.AnswersOverview": "Answers overview",
    "Insights.Interested.PageHeading": "Interested accounts",
    "Insights.Live.AmountText.Single": "participant has watched live",
    "Insights.Live.AmountText.Multiple": "participants have watched live",
    "Insights.Live.PageHeading": "Live participants",
    "Insights.OnDemand.AmountText.Single": "participant has watched on demand",
    "Insights.OnDemand.AmountText.Multiple": "participants have watched on demand",
    "Insights.OnDemand.PageHeading": "On Demand participants",
    "Insights.Polls.AmountText": "Number of poll questions asked:",
    "Insights.Polls.Button.Export": "Export poll results",
    "Insights.Polls.PageHeading": "Poll results",
    "Insights.Polls.Select.Combined": "Combined poll results",
    "Insights.Polls.Select.Label": "Show poll results",
    "Insights.Polls.Select.Live": "Live poll results",
    "Insights.Polls.Select.OnDemand": "On demand poll results",
    "Insights.Survey.AmountText": "Number of survey questions asked:",
    "Insights.Survey.PageHeading": "Survey results",
    "Insights.Survey.Button.Export": "Export results",
    "Insights.Survey.Select.Combined": "Combined survey results",
    "Insights.Survey.Select.Label": "Show survey results",
    "Insights.Survey.Select.Live": "Live survey results",
    "Insights.Survey.Select.OnDemand": "On demand survey results",

    "Invites.Button.DeleteParticipant": "Remove {{email}} from the imported participants",
    "Invites.Button.EmailPending": "E-mail pending invites",
    "Invites.Button.EmailReminder": "E-mail reminders",
    "Invites.Button.Import": "Import participants",
    "Invites.Button.ResendAllInvites": "Resend all invites",
    "Invites.Button.ResendAllReminders": "Resend all reminders",
    "Invites.Settings.AutoSendInvite": "Send invite automatically after import",
    "Invites.Settings.AutoSendReminder": "Automatically send reminder",
    "Invites.Settings.ReminderHoursBeforeWebinar": "Hours before webinar",
    "Invites.Button.ResetInvite": "Resend invite to {{email}}",
    "Invites.Dialog.Emailing.Progress": "Sending {{current}} of {{total}}",
    "Invites.Dialog.Emailing.Title": "Sending emails",
    "Invites.Heading.ImportedParticipants": "Imported participants",
    "Invites.PageHeading": "Invite participants",

    "Campaign.New": "New campaign",
    "Campaign.NewName": "New campaign",
    "Campaign.Table.Name": "Name",
    "Campaign.Table.Created": "Created",
    "Campaign.Table.Status": "Status",
    "Campaign.Table.Sent": "Sent",
    "Campaign.Table.InterestedNow": "Interested now",
    "Campaign.Status.Draft": "Draft",
    "Campaign.Status.Sent": "Sent",
    "Campaign.Field.Name": "Campaign name",
    "Campaign.Field.Name.Edit": "Edit campaign name",
    "Campaign.Tab.Audience": "Audience",
    "Campaign.Tab.Addresses": "Addresses",
    "Campaign.Tab.EmailTemplate": "E-mail template",
    "Campaign.Lists.Heading": "Audience",
    "Campaign.Lists.Webinar": "Webinar lists",
    "Campaign.Lists.Global": "Global lists",
    "Campaign.Lists.CreateWebinarList": "Import a new list for this webinar",
    "Campaign.Lists.SelectExistingList": "Select existing list",
    "Campaign.Lists.AddSelected": "Add selected",
    "Campaign.Lists.NoGlobalLists": "No global lists available to add.",
    "Campaign.Lists.RemoveGlobalList": "Remove list {{name}}",
    "Campaign.Lists.DeleteWebinarList": "Delete list {{name}}",
    "Campaign.Send": "Send",
    "Campaign.Warning.NotPublished": "Sending is not possible because the webinar is not published yet.",

    "Campaign.CannotSend.Header": "This campaign cannot be sent yet:",
    "Campaign.CannotSend.IncompleteSubject": "Enter a subject for the e-mail template",
    "Campaign.CannotSend.IncompleteBody": "Complete the body of the e-mail template",
    "Campaign.CannotSend.NoLists": "Select at least one list",
    "Campaign.CannotSend.NotPublished": "The webinar is not published",
    "Campaign.Delete": "Delete campaign",
    "Campaign.SendConfirm.Title": "Send this campaign?",
    "Campaign.SendConfirm.Body": "The e-mail will be sent to the selected lists. After sending, the campaign can no longer be edited.",
    "Campaign.DeleteConfirm.Title": "Delete this campaign?",
    "Campaign.DeleteConfirm.Body": "This permanently deletes the campaign. This action cannot be undone.",
    "Campaign.Detail.SentAt": "Sent on",
    "Campaign.Detail.NotSent": "Not sent",
    "Campaign.Detail.RecipientCount": "Recipients",
    "Campaign.Detail.EstimatedRecipients": "Recipients (estimated)",
    "Campaign.Detail.Sent": "Sent",
    "Campaign.Detail.Failed": "Failed",
    "Campaign.Detail.Blacklisted": "Blacklisted",
    "Campaign.Detail.AlreadyInterested": "Already interested",
    "Campaign.Detail.AlreadySentInAnotherList": "Skipped (other list)",
    "Campaign.Detail.InterestedNow": "Interested now",
    "Campaign.Detail.RecipientsHeading": "Recipients",
    "Campaign.AddLists.Heading": "Send to more lists",
    "Campaign.AddLists.Intro": "Add more lists to reach new people. Anyone already in this campaign is skipped automatically.",
    "Campaign.AddLists.Button": "Add & send",
    "Campaign.AddLists.NoSelectionHint": "Select at least one list to send to.",
    "Campaign.AddLists.None": "All your lists for this webinar are already in this campaign.",
    "Campaign.Recipients.Search": "Search",
    "Campaign.Recipients.StatusFilter": "Filter by status",
    "Campaign.Recipients.AllStatuses": "All statuses",
    "Campaign.Recipients.Email": "E-mail address",
    "Campaign.Recipients.Name": "Name",
    "Campaign.Recipients.Company": "Company",
    "Campaign.Recipients.List": "List",
    "Campaign.Recipients.SentAt": "Sent on",
    "Campaign.Recipients.Status": "Status",
    "Campaign.Recipients.Empty": "No recipients found.",
    "Campaign.RecipientStatus.Pending": "Pending",
    "Campaign.RecipientStatus.Sent": "Sent",
    "Campaign.RecipientStatus.Failed": "Failed",
    "Campaign.RecipientStatus.Blacklisted": "Blacklisted",
    "Campaign.RecipientStatus.AlreadyInterested": "Already interested",
    "Campaign.RecipientStatus.AlreadySentInAnotherList": "Skipped (other list)",
    "Campaign.SelectList.Heading": "Select a list",
    "Campaign.SelectList.Back": "Back to lists",
    "Campaign.SelectList.UseList": "Use this list",
    "Campaign.SelectList.Empty": "No lists available.",

    "Generic.Pagination.Previous": "Previous",
    "Generic.Pagination.Next": "Next",
    "Generic.Pagination.PageOf": "Page {{page}} of {{total}}",

    "Invites.Table.Header.InvitedAt": "Invited at",
    "Invites.Table.Header.Status": "Invite",
    "Invites.Table.Header.ReminderStatus": "Reminder",

    "LiveTranscribe.Label.DeepgramLanguage": "The spoken language in this webinar",
    "LiveTranscribe.Label.DeepgramDefault": "Use Deepgram as the default transcription tool",
    "LiveTranscribe.Label.DeepgramEnabled": "Enable live transcription using Deepgram",
    "LiveTranscribe.Label.DeepgramModel": "Deepgram model",
    "LiveTranscribe.Label.SmartFormat": "Enable Smart Format. Smart Format can automatically format transcripts to improve readability.",
    "LiveTranscribe.Label.TrackId": "Track ID",
    "LiveTranscribe.Option.DeepgramLanguage.Dutch": "Dutch",
    "LiveTranscribe.Option.DeepgramLanguage.English": "English",
    "LiveTranscribe.Option.DeepgramLanguage.French": "French",
    "LiveTranscribe.Option.DeepgramLanguage.German": "German",
    "LiveTranscribe.Option.DeepgramLanguage.Multi": "Multiple languages",
    "LiveTranscribe.PageHeading": "Live transcription",
    "LiveTranscribe.SectionHeader.DeepgramSettings": "Deepgram settings",

    "MainMenu.Content": "Webinar content",
    "MainMenu.CreateNew": "Create new webinar",
    "MainMenu.Label": "Main menu",
    "MainMenu.ManageEnv": "Manage environment",
    "MainMenu.Overview": "Organized webinars",
    "MainMenu.Share": "Share",
    "MainMenu.Schedule": "Webinar schedule",
    "MainMenu.Support": "Help",
    "MainMenu.Toggle.Close": "Close menu",
    "MainMenu.Toggle.Open": "Open menu",

    "Manage.Link.AccountInvites": "Invite participants",
    "Manage.Link.EmailStyle": "Manage e-mail template style",
    "Manage.Link.EmailTemplates": "Manage e-mail templates",
    "Manage.Link.ManagePrepend": "Manage",
    "Manage.Link.Translation": "Manage translation",
    "Manage.Link.WebinarDuration": "View the settings",
    "Manage.PageHeading": "Manage environment",

    "Marketing.PageHeading": "Marketing",

    "Menu.Dropdown.Options": "Options",

    "OptionMenu.Content": "Edit",
    "OptionMenu.EditOnDemand": "Edit on demand",
    "OptionMenu.Insights": "Insights",
    "OptionMenu.Marketing": "Marketing",
    "OptionMenu.Pay": "Pay now",
    "OptionMenu.Security": "Security",
    "OptionMenu.Share": "Share",
    "OptionMenu.ShareOnDemand": "Share on demand",
    "OptionMenu.SlideController": "Slide controller",
    "OptionMenu.Test": "Test connection",
    "OptionMenu.WatchOnDemand": "Watch on demand",

    "Pages.404.Header": "Oops",
    "Pages.404.Text": "We can't find this page. You can go to the webinar schedule or go back to the previous page.",
    "Pages.404.SideContent.Header": "Why?",
    "Pages.404.SideContent.Text": "This is not how it is supposed to be!!",
    "Pages.Auth.SideContent.Header": "Hello there!",
    "Pages.Auth.SideContent.Text": "Enjoy watching your webinar!",
    "Pages.ForgotPassword.Header": "Forgot Password",
    "Pages.Login.Header": "Log in or create an account",
    "Pages.Organized.Header": "Organized webinars",
    "Pages.Organized.Heading.OnDemand": "On demand webinars",
    "Pages.Organized.Heading.Upcoming": "Upcoming webinars",
    "Pages.Organized.NoEnded.Title": "No ended webinars",
    "Pages.Organized.NoEnded.Text": "Webinars that have finished will be listed here.",
    "Pages.Organized.NoUpcoming.Title": "Nothing to see here yet",
    "Pages.Organized.NoUpcoming.Text": "Webinars you have organized will appear here. Why not try it now?",
    "Pages.Organized.NoUpcoming.Button": "Create your own webinar",
    "Pages.Organized.TabEnded": "Ended webinars",
    "Pages.Organized.TabOnDemand": "On demand webinars",
    "Pages.Organized.TabUpcoming": "Upcoming webinars",
    "Pages.Organized.TabSearch": "Search results",
    "Pages.Organized.NotFound.Title": "No results found",
    "Pages.Organized.NotFound.Text": "No webinars match your search. Try a different keyword.",
    "Pages.Organized.Heading.Found": "Search results",
    "Pages.Register.Header": "Register",
    "Pages.Register.Webinar.CreateAccount": "To be able to watch this webinar, you will need to login with an account or create an new account:",
    "Pages.Register.Webinar.Interested": "You are interested in the following webinar:",
    "Pages.Register.WebinarModerator": "You are invited to moderate the following webinar:",
    "Pages.Register.WebinarModerator.CreateAccount": "To moderate this webinar, you will need to login with an account or create an new account:",
    "Pages.Register.WebinarBroadcaster": "You are invited to broadcast the following webinar:",
    "Pages.Register.WebinarBroadcaster.CreateAccount": "To be able to broadcast this webinar, you will need to login with an account or create an new account:",

    "Participants.Online": "Online:",
    "Participants.Search.Label": "Filter",

    "Player.Button.Fullscreen": "Full screen",
    "Player.Button.ExitFullscreen": "Exit full screen",
    "Player.Button.Poll": "Poll",
    "Player.Button.Subtitles": "Subtitles",
    "Player.Chapters.Add": "You can add some chapters",
    "Player.Chapters.Heading": "Chapters",
    "Player.NoChapters": "No chapters to display yet",
    "Player.Chat.ForwardedFrom": "Message forwarded from ",
    "Player.Chat.Global": "Public",
    "Player.Chat.Header": "Chat",
    "Player.Chat.Nickname.Required": "Please enter a nickname to participate in the chat.",
    "Player.Chat.Nickname.Placeholder": "Your nickname",
    "Player.Chat.Nickname.UpdateButton": "Update nickname",
    "Player.Chat.InputPlaceHolder": "Do you have a question or comment? Type your message here",
    "Player.Chat.Live.Ended": "The webinar has ended and all moderator are offline now, no chat possible anymore",
    "Player.Chat.OnDemand": "You can send your message here, it will be forwarded to the organizer of this webinar.",
    "Player.Chat.Private": "Support",
    "Player.Chat.Send": "Send message",
    "Player.Info.State.CountDownWithTime": "The webinar starts in:",
    "Player.Info.State.WebinarStarting": "One moment please, the webinar will resume in a few moments",
    "Player.Menu.Chapters": "Chapters",
    "Player.Menu.Chat": "Chat",
    "Player.Menu.NewSlide": "new slide",
    "Player.Menu.Slides": "Slides",
    "Player.Menu.UnreadMessages_one": "{{count}} unread message",
    "Player.Menu.UnreadMessages_other": "{{count}} unread messages",
    "Player.Menu.Video": "Video",
    "Player.NoPolls": "No polls to display yet",
    "Player.Poll.ResultsAtEndMessage": "Thank you for voting.",
    "Player.SubtitleSelect.NoSubtitles": "Subtitles off",
    "Player.ThanksForWatching.Button.Replay": "Replay",
    "Player.ThanksForWatching.Heading": "Thank you for watching!",
    "Player.ThanksForWatching.Link.Url": "/",
    "Player.ThanksForWatching.Link.Overview": "Webinar schedule",
    "Player.Resume.Loading": "Loading…",
    "Player.Resume.Notice": "Resuming where you left off",
    "Player.Recovery.Reconnecting": "Reconnecting…",
    "Player.Recovery.Failed": "The video could not be restored.",
    "Player.Recovery.TryAgain": "Try again",
    "Player.UserInputButton.Audio": "Enable audio",
    "Player.UserInputButton.Play": "Play",

    "poll.viewIconLabel": "icon-poll",

    "presentationSlide.NoSlide": "No slide to display",
    "presentationSlide.Upload": "Please upload",

    "ProcessedFollowUp.Button.Export": "Export list",
    "ProcessedFollowUp.Heading.SentTo": "Follow-up sent to",
    "ProcessedFollowUp.PageHeading": "Sent follow-up",
    "ProcessedFollowUp.TableHeader.CreatedAt": "Sent at",
    "ProcessedFollowUp.TableHeader.EmailStatus": "Status",
    "ProcessedFollowUp.TableHeader.ExamAnswers": "Exam answers",
    "ProcessedFollowUp.TableHeader.ExamPoints": "Exam points",
    "ProcessedFollowUp.TableHeader.Name": "Name",
    "ProcessedFollowUp.TableHeader.OnlinePercentage": "Percentage watched",
    "ProcessedFollowUp.TableHeader.PollPoints": "Poll points",
    "ProcessedFollowUp.TableHeader.PollVotes": "Poll votes",
    "ProcessedFollowUp.TableHeader.SurveyAnswers": "Survey answers",

    "Questionnaire.Accreditation": "Accreditation is provided by:",
    "Questionnaire.Button.End": "Close",
    "Questionnaire.Button.Next": "Next",
    "Questionnaire.Button.Previous": "Back",
    "Questionnaire.Button.Retry": "Retake the exam",
    "Questionnaire.Button.StartExam": "Take the exam",
    "Questionnaire.Exam.WrongAnswers": "You answered the following questions incorrectly:",
    "Questionnaire.OpenQuestion.Placeholder": "Your answer",
    "Questionnaire.OtherAnswer.Placeholder": "Please enter your answer",
    "Questionnaire.Preface": "Preface",
    "Questionnaire.Progress": "Question {{number}} of {{total}}",
    "Questionnaire.Question.Required": "This question is required",
    "Questionnaire.Result": "Result",
    "Questionnaire.ResultLoading": "Determining your result",
    "Questionnaire.Retakes": "Number of available retakes: <strong>{{retakes}}</strong>.",
    "Questionnaire.WrongAnswers": "You answered the following <strong>{{amount}}</strong> exam questions wrong:",

    "ResetPassword.PageHeading": "Reset password",

    "resumeConfirmationMessage.withTimer": "The webinar is paused and will be resumed in:",

    "Schedule.LoginToSeeWebinars": "Some webinars might not be visible. Please <a>log in</a> for a complete overview of all webinars.",
    "Schedule.NoPublicWebinars.Text": "At the moment there are no public webinars available. Please check back later, or log in to see the complete list of webinars.",
    "Schedule.NoWebinars.Title": "Nothing to see here yet",
    "Schedule.NoWebinars.Text": "Webinars you have indicated you are interested in will appear here.",
    "Schedule.PageHeading": "Webinar schedule",
    "Schedule.ShowMoreOndemand": "Show all on demand webinars",
    "Schedule.ShowMoreUpcoming": "Show all upcoming webinars",
    "Schedule.Switch.ShowInterested": "Only show webinars I have registered for.",
    "Schedule.UpNext": "Up next",

    "Search.Button.Clear.AriaLabel": "Clear selection",
    "Search.Placeholder": "Search for a webinar",

    "Security.AllowAnonymousWarning": "Allowing anonymous viewers means that anyone with the link to your webinar can watch it, even if they are not logged in. As such this bypasses all security measures. Only share the link to your webinar with people you trust. As an additional security measure, you can set an authorization code that will generate a special webinar link for anonymous viewers.",
    "Security.AnonymousViewerAuthorizationCodeLabel": "Anonymous viewer authorization code",
    "Security.AnonymousViewerLinkLabel": "Anonymous viewer link:",
    "Security.Button.GenerateCode": "Generate code",
    "Security.Introtext": "On this page you can allow or disallow accounts from viewing this webinar. You can do this by entering one or more e-mail adresses. It is also possible to in- or exclude e-mail adresses from a domain, by entering @domainname (for example @onlinewebinar.com).",
    "Security.InfoText.Important": "Important!",
    "Security.InfoText.Item1": "Disallow takes precedence over allow. This means that if you disallow an entire domain, it is impossible to allow a single account with an e-mail address from that domain.<br /> The other way around will work: you can allow accounts with e-mail addresses from a particular domain. Disallowing an e-mail address from this domain will still prevent this account from watching this webinar.",
    "Security.InfoText.Item2": "Disallowing accounts will only prevent them from being able to watch your webinar. They will still be able to see the detail page for your webinar.",
    "Security.Filter.Allow": "Allow filter",
    "Security.Filter.Disallow": "Disallow filter",
    "Security.Filter.Button.Save": "Save your filter",
    "Security.FilterResults.Heading": "Filter results",
    "Security.FilterResults.Label.TestResults": "Test e-mail address",
    "Security.FilterResults.Table.Header.Email": "Email address",
    "Security.PageHeading": "Webinar Security",
    "Security.Switch.OneViewerSession": "Only allow one viewer session per participant",
    "Security.Switch.RequireVerified": "Require verified accounts",
    "Security.Switch.AllowAnonymous": "Allow anonymous viewers",

    "Share.Button.CopyLink": "Copy link",
    "Share.CopiedLink": "Link copied successfully",
    "Share.InviteBroadcaster.Heading": "Invite a broadcaster using a link",
    "Share.InviteBroadcaster.Text": "You can invite one or more broadcasters for your webinar by sharing this link:",
    "Share.InviteBroadcaster.WarningText": "Important! Only share this link with people you trust.",
    "Share.InviteModerator.Heading": "Invite a moderator using a link",
    "Share.InviteModerator.Text": "You can invite one or more moderators for your webinar by sharing this link:",
    "Share.InviteModerator.WarningText": "Important! Only share this link with people you trust.",
    "Share.InviteParticipants.AnonymousEnabled.WarningText": "Important! Only share this link with people you trust. Anonymous viewers has been enabled which means that anyone with the link to your webinar can watch it, even if they are not logged in. As such this bypasses all security measures.",
    "Share.InviteParticipants.Heading": "Invite participants using a link",
    "Share.InviteParticipants.Text": "You can invite others to sign up for and view your webinar by sharing this link:",
    "Share.InviteSpeaker.Heading": "Invite a speaker using a link",
    "Share.InviteSpeaker.Text": "You can invite one or more speakers for your webinar by sharing this link:",
    "Share.PageHeading": "Share your webinar",
    "Share.SignUps": "Sign ups",
    "Share.InviteAnonymous.Heading": "Invite anonymous viewers using a link",
    "Share.InviteAnonymous.Text": "You can invite anonymous viewers for your webinar by sharing this link:",
    "Share.InviteAnonymous.WarningText": "Important! Only share this link with people you trust. Allowing anonymous viewers means that anyone with the link to your webinar can watch it, even if they are not logged in. As such this bypasses all security measures.",

    "Speaker.List.Heading": "Speakers ({{count}})",
    "Speaker.List.Button.Notify": "Notify {{name}}",
    "Speaker.List.Button.Kick": "Remove {{name}} from the webinar",
    "Speaker.Status.Offline": "Offline",
    "Speaker.Status.SettingUp": "Setting up",
    "Speaker.Status.AwaitingAdmission": "Awaiting admission",
    "Speaker.Status.Connecting": "Connecting",
    "Speaker.Status.NotReady": "Not ready",
    "Speaker.Status.Ready": "Ready",
    "Speaker.Status.GoingLive": "Going live",
    "Speaker.Status.OnAir": "On air",
    "Speaker.Status.Error": "Error",
    "Speaker.Status.Banned": "Banned",

    "Speaker.WaitingRoom.Heading": "Speaker waiting room",
    "Speaker.WaitingRoom.Kicked": "You have been removed from the webinar by the broadcaster.",
    "Speaker.WaitingRoom.Notified": "The broadcaster wants your attention.",
    "Speaker.WaitingRoom.Status.Live": "The webinar is live.",
    "Speaker.WaitingRoom.Status.WaitingReady": "You're ready — waiting for the broadcaster to bring you on air.",
    "Speaker.WaitingRoom.Status.WaitingNotReady": "Flip \"I'm ready to go on air\" when you want to let the broadcaster know you're ready.",
    "Speaker.WaitingRoom.ReadyToggle.Label": "I'm ready to go on air",

    "Slide.Button.Current": "Go to current slide",
    "Slide.Button.First": "Go to first slide",
    "Slide.Button.Next": "Next slide",
    "Slide.Button.Previous": "Previous slide",

    "Status.Message.Interrupted": "Broadcast is interrupted. Please wait.",
    "Status.Message.NotStarted": "Broadcast has not started yet. Please wait.",
    "Status.Message.Paused": "Broadcast is paused. Please wait.",

    "TestSuite.Button.RetryTest": "Run the test again",
    "TestSuite.Button.StartTest": "Start the test",
    "TestSuite.BroadcastConnection.Error": "There was an error connecting the broadcast video. Please refresh the page.",
    "TestSuite.BroadcastConnection.UnstableNetwork": "The network connection is unstable. Please check your internet connection.",
    "TestSuite.BroadcastConnection.VeryUnstableNetwork": "The network connection is very unstable. Please check your internet connection.",
    "TestSuite.BroadcastScore.Audio": "Audio score:",
    "TestSuite.BroadcastScore.Video": "Video score:",
    "TestSuite.BroadcastState.Broadcasting": "Broadcasting",
    "TestSuite.BroadcastState.Initializing": "Initializing",
    "TestSuite.BroadcastState.NotBroadcasting": "Not broadcasting",
    "TestSuite.Connection.Connected": "Connected",
    "TestSuite.Connection.Connecting": "Connecting",
    "TestSuite.Connection.Disconnected": "Disconnected",
    "TestSuite.Connection.Label": "Connection:",
    "TestSuite.PageHeading": "Get set for your webinar",
    "TestSuite.PlayerConnection.Error": "There was an error connecting the player video. Please refresh the page.",
    "TestSuite.PlayerConnection.Live": "Live",
    "TestSuite.PlayerConnection.NotLive": "Not live",
    "TestSuite.PlayerState.Buffering": "Buffering",
    "TestSuite.PlayerState.Paused": "Paused",
    "TestSuite.PlayerState.Playing": "Playing",
    "TestSuite.Progress.Label": "Testing",
    "TestSuite.State.Label": "Status:",
    "TestSuite.Text.Disclaimer": "<em>Please note:</em> The test only provides a snapshot. <br/>If you change your internet connection or the quality of your network later, run the test again to make sure everything is working properly.",
    "TestSuite.Text.Explanation": "On the left you will see your source video, and on the right what your viewers will see. There will be a slight delay between your video, and the video the viewers see.",
    "TestSuite.Text.PreTest": "This test allows you to check if your connection to the OnlineWebinar servers is working properly. We'll check for one minute to ensure the video and audio are properly transmitted.<br/>For this test, use the same computer and camera you'll use during the broadcast.",
    "TestSuite.Text.TestEnded": "The test has ended. If everything looks good, you are ready to start your webinar!",
    "TestSuite.Text.RetryTest": "Retry the test",
    "TestSuite.Transport.Label": "Connection type:",
    "TestSuite.Transport.Moq": "Media over QUIC ({{transport}})",
    "TestSuite.Transport.MoqUnknown": "Media over QUIC",
    "TestSuite.Transport.Classic": "Classic connection (WebRTC)",
    "TestSuite.Transport.MoqFailed": "Media over QUIC did not connect; the test continues over the classic connection.",
    "TestSuite.ApiErrorCode.NotReadyException": "Please try again later.",
    "TestSuite.ApiErrorCode.NotReadyException.Body": "There are currently no test channels available. Please try again later.",
    "Title.ForWebinar": "{{page}} for {{webinar}}",
    "Title.RegisterForWebinar": "Register for {{webinar}}",
    "Title.WatchWebinar": "Watch {{webinar}}",
    "Title.EditWebinar": "Edit {{webinar}}",
    "Title.Upcoming": "Overview of upcoming webinars",
    "Title.OnDemand": "Overview of on demand webinars",
    "Title.VerifyAccount": "Verify your account",
    "Title.Unsubscribe": "Unsubscribe",
    "Title.NotFound": "Page not found",
    "Title.AccountManagerInvite": "Account manager invitation",
    "Title.BroadcastWebinar": "Broadcast {{webinar}}",
    "Title.Moderator": "Moderator",
    "Title.SlideController": "Slide controller",
    "Title.DeleteWebinar": "Delete {{webinar}}",
    "Title.ShareWebinar": "Share {{webinar}}",
    "Title.Content": "Content",
    "Title.Analytics": "Analytics",
    "Title.OrganizedUpcoming": "Organized upcoming webinars",
    "Title.OrganizedEnded": "Organized ended webinars",

    "Translation.InfoText": "The updated translation file requires to be either a JSON-translation file or an Excel file. The Excel file should have two columns, the first column should contain the key and the second column should contain the translation. The first row should contain the headers “Key” and “Translation”.",
    "Translation.PageHeading": "Manage translation",
    "Translation.Table.Header.Key": "Key",
    "Translation.Table.Header.Translation": "Translation",

    "Validation.Email.Required": "The email address has not been filled in.",
    "Validation.Email.Invalid": "The email address is not valid. A valid email address has an @ followed by a domain with a dot, without spaces. For example: name@example.com",
    "Validation.Email.MaxLength": "Email can be a maximum of 245 characters",
    "Validation.CompanyName.MaxLength": "Company can be a maximum of 100 characters",
    "Validation.ForgotPasswordCode.Required": "The code has not been filled in.",
    "Validation.Password.Required": "The password has not been filled in.",
    "Validation.Password.ComplexityScore0": "Password is very weak. Please use a stronger password.",
    "Validation.Password.ComplexityScore1": "Password is weak. Please use a stronger password.",
    "Validation.Password.ComplexityScore2": "Password is moderate. Please use a stronger password.",
    "Validation.Password.ComplexityScore3": "Password is strong",
    "Validation.Password.ComplexityScore4": "Password is very strong",
    "Validation.Nickname.Required": "The nickname has not been filled in.",
    "Validation.Nickname.MinLength": "Nickname must be at least 3 characters",
    "Validation.Nickname.MaxLength": "Nickname can be a maximum of 70 characters",
    "Validation.FirstName.Required": "The first name has not been filled in.",
    "Validation.FirstName.MaxLength": "First name can be a maximum of 35 characters",
    "Validation.LastName.Required": "The last name has not been filled in.",
    "Validation.LastName.MaxLength": "Last name can be a maximum of 35 characters",
    "Validation.TermsOfAgreement.Required": "You must agree to the terms and conditions",

    "Video.Initializing": "We're initializing audio and video. Please allow access to your camera and microphone when prompted.",

    "Viewer.Message.Button.InterestedOverview": "Subscribed webinars",
    "Viewer.Message.MultipleSessions": "It seems you are watching this webinar in another browser window or tab, or on another device.<br />You can refresh this page to continue watching here.",
    "Viewer.Message.TestWebinarFull": "This test webinar has reached its maximum of {{maxViewers}} viewers.",
    "Viewer.Message.WebinarCancelled": "The webinar you want to watch has been canceled.",
    "Viewer.Message.WebinarExpired": "The webinar you want to watch did not take place.",
    "Viewer.Message.WebinarPlanned": "This webinar will start in",
    "Viewer.Message.WebinarNotStarted": "The webinar has not started yet, please wait",
    "Maintenance.Notice.Title": "Maintenance",
    "Maintenance.Gateway.Title": "Maintenance in progress",
    "Maintenance.Gateway.Body": "The platform is temporarily unavailable for maintenance. This page continues automatically as soon as the platform is back.",
    "Viewer.Message.ConnectionLost": "The connection to the webinar was lost. Please check your internet connection and refresh the page.",
    "Viewer.Message.ConnectionConnecting": "Connecting to the webinar, please wait...",

    "WebinarAnalytics.Heading.AudioPackets": "Audio packets sent",
    "WebinarAnalytics.Heading.AudioScore": "Audio score",
    "WebinarAnalytics.Heading.BytesSent": "Bytes sent",
    "WebinarAnalytics.Heading.PacketDelay": "Packet delay",
    "WebinarAnalytics.Heading.RetransmittedPackets": "Retransmitted packets sent",
    "WebinarAnalytics.Heading.VideoPackets": "Video packets sent",
    "WebinarAnalytics.Heading.VideoScore": "Video score",
    "WebinarAnalytics.PageHeading": "Webinar analytics",

    "WebinarButton.Status.Cancelled": "View Details",
    "WebinarButton.Status.Ended": "Insights",
    "WebinarButton.Status.Expired": "Edit webinar",
    "WebinarButton.Status.Started": "Broadcast",
    "WebinarButton.Status.Planned": "Broadcast",

    "Webinar.Button.Reschedule": "Reschedule",
    "Webinar.Data.Attachment": "attachments",
    "Webinar.Data.Exam": "exam",
    "Webinar.Data.Heading": "Status",
    "Webinar.Data.Status.NotEnabled": "No",
    "Webinar.Data.Status.Enabled": "Yes",
    "Webinar.Data.Status.NotValid": "Not valid",
    "Webinar.Data.Chapters": "chapters",
    "Webinar.Data.Interested": "interested",
    "Webinar.Data.OndemandViews": "on demand views",
    "Webinar.Data.Polls": "polls",
    "Webinar.Data.Security": "security",
    "Webinar.Data.Slides": "slides",
    "Webinar.Data.Survey": "survey",
    "Webinar.Data.Viewers": "viewers",
    "Webinar.DateTime.StartIn": "Start in:",
    "Webinar.DateTime.StartNow": "Start now",
    "Webinar.Live": "Live",
    "Webinar.StatusMessage.Cancelled": "This webinar has been <span>cancelled</span>.",
    "Webinar.StatusMessage.Expired": "This webinar has <span>expired</span>.",
    "Webinar.StatusMessage.Timeslot": "The selected timeslot for this webinar is not available! <span>Please reschedule your webinar!</span>",
    "Webinar.Visibility.Private": "Private",
    "Webinar.Warning.NotPublished": "Not published",
    "Webinar.Warning.NotPublished.Body": "This webinar has not been published yet and is not visible to viewers.",
    "Webinar.Warning.NoBooking": "Timeslot not available",
    "Webinar.Warning.NoBooking.Body": "There is no timeslot available for this webinar. You cannot broadcast the webinar.",
    "Webinar.Warning.Dangerzone": "Dangerzone",
    "Webinar.Button.Cancel": "Cancel webinar",
    "Webinar.Button.Delete": "Delete this webinar",
    "Webinar.Delete.Deletecode.Label": "Confirm delete code",
    "Webinar.Delete.DeleteCode": "Please enter the code to confirm deletion. Note that this code is case-sensitive.",
    "Webinar.Delete.PageHeading": "Delete webinar",
    "Webinar.Delete.Warning": "Are you sure you want to delete the following webinar? This is permanent and cannot be undone.",
    "Webinar.Warning.WebinarIsCancelled": "This webinar is cancelled.",
    "Webinar.Warning.WebinarIsCancelled.Body": "This webinar is cancelled and cannot be watched but is still visible.",
    "Webinar.CancelWebinar.Title": "Cancel webinar",
    "Webinar.CancelWebinar.Description": "Are you sure you want to cancel this webinar? This cannot be undone.",
    "Webinar.CancelWebinar.Button.Close": "No",
    "Webinar.CancelWebinar.Button.Cancel": "Yes, cancel webinar",
    "Webinar.RescheduleWebinar.Title": "Reschedule webinar",
    "Webinar.RescheduleWebinar.Description": "You are responsible for notifying the participants about the new broadcast date and time. Do you want to continue?",
    "Webinar.Test.Badge": "Test webinar",
    "Webinar.Test.Switch.Label": "This is a test webinar",
    "Webinar.Test.Confirm.Title": "Plan as a test webinar?",
    "Webinar.Test.Confirm.Description": "A test webinar lasts at most {{maxDurationMinutes}} minutes, admits at most {{maxViewers}} viewers and is not billed. It is deleted automatically {{deleteAfterStartHours}} hours after its planned start, recording included, and it cannot be turned into a real webinar afterwards.",
    "Webinar.Test.Confirm.Button.Confirm": "Yes, plan a test webinar",
    "Webinar.Test.Confirm.Button.Close": "No",
    "Webinar.Test.Notice.Title": "This is a test webinar",
    "Webinar.Test.Notice.Body": "At most {{maxDurationMinutes}} minutes and {{maxViewers}} viewers, not billed.",
    "Webinar.Test.Notice.DeleteOn": "It is deleted automatically after {{deleteOn}}, recording included.",
    "Webinar.Test.DeleteOn": "Deleted automatically after {{deleteOn}}",
    "Webinar.Test.Countdown.Limit": "Test webinar: the broadcast ends automatically after {{maxDurationMinutes}} minutes",
    "Webinar.Test.Countdown.Ending": "Test webinar: ends automatically in",
    "Webinar.Schedule.Warning.TestDurationMaximum": "A test webinar can be no longer than {{maxDuration}} minutes",

    "WebinarDetails.Button.NoLongerInterested": "No longer interested",
    "WebinarDetails.Button.Interested": "Interested",
    "WebinarDetails.Button.UploadBannerImage.AriaLabel": "Upload banner image for this webinar",
    "WebinarDetails.Button.UploadProfileImage.AriaLabel": "Upload profile image for this webinar",
    "WebinarDetails.Button.UseDefaultBannerImage.AriaLabel": "Delete image and use the default banner image",
    "WebinarDetails.Button.UseDefaultProfileImage.AriaLabel": "Delete image and use the default profile image",
    "WebinarDetails.Button.UseDefaultImage": "Use default",
    "WebinarDetails.Button.WatchIn": "Watch in {{watchCountdown}}",
    "WebinarDetails.Button.VerifyToWatch": "Verify to watch",
    "WebinarDetails.By": "by",
    "WebinarDetails.Label.Date": "Date",
    "WebinarDetails.Label.Duration": "Duration",
    "WebinarDetails.Label.Host": "Host",
    "WebinarDetails.Label.Time": "Time",
    "WebinarDetails.Label.Visibility.Private": "Private webinar: this webinar will only be visible for people who received an invite or a share link.",
    "WebinarDetails.Label.Visibility.Public": "Public webinar: this webinar will be visible in the overview.",
    "WebinarDetails.Legend.Visibility": "Webinar visibility",
    "WebinarDetails.Section.OnDemand": "On-demand",
    "WebinarDetails.Label.OnDemand.Enabled": "Allow viewers to watch on-demand",
    "WebinarDetails.Info.OnDemandPreparing": "Your recording is being prepared. Please check back soon.",
    "Content.OnDemand.Status.Processing": "Processing",
    "Content.OnDemand.Status.Available": "Available",
    "Content.OnDemand.Status.Failed": "Failed",
    "WebinarDetails.Link.BackToOverview": "Back to upcoming webinars",
    "WebinarDetails.Heading.Attachments": "Attachments",
    "WebinarDetails.Heading.Related": "Listen to this webinar as a podcast",
    "WebinarDetails.Warning.AccessRestricted": "Access to this webinar has been restricted",
    "WebinarDetails.Warning.LinkExpired": "Your personal link has expired.",
    "WebinarDetails.Warning.OnDemandNotAvailable": "This webinar has ended and is currently not available as on demand.",

    "WebinarDurationSettings.Figure.ChannelAllocation": "Channel allocation",
    "WebinarDurationSettings.Figure.ChannelInUse": "Channel in use",
    "WebinarDurationSettings.Figure.PlannedDuration": "Planned duration",
    "WebinarDurationSettings.Figure.PlannedEndTime": "Planned webinar end time",
    "WebinarDurationSettings.Figure.PlannedStartTime": "Planned webinar start time",
    "WebinarDurationSettings.Figure.RunOutTime": "Run-out time",
    "WebinarDurationSettings.InfoText": "<p>A channel is reserved for giving a webinar. How long this is depends on three things:</p> <ul><li>The time before the planned start time when the channel is assigned. From this moment the broadcast can be started.</li><li>The planned duration of the webinar.</li><li>The extension time after the planned duration of the webinar.</li></ul><p></p>",
    "WebinarDurationSettings.PageHeading": "Webinar duration settings",
    "WebinarDurationSettings.Text.DurationAfterEnd": "Extra run-out time after the planned end time:",
    "WebinarDurationSettings.Text.DurationBeforeStart": "Time the channel is allocated before the planned start time:",
    "WebinarDurationSettings.Text.MaxDuration": "The maximum planned duration of a webinar:",
    "WebinarDurationSettings.Text.TotalDuration": "The total maximum duration of a webinar:",

    "webinarProgress.failedToLoadStreamText": "failed to load the video stream",

    "Webinar.Schedule.Label.BroadcastDate": "Broadcast date",
    "Webinar.Schedule.Label.ClientReference": "Client reference",
    "Webinar.Schedule.Label.Description": "Description",
    "Webinar.Schedule.Label.Duration": "Duration",
    "Webinar.Schedule.Label.HostName": "Name of the host",
    "Webinar.Schedule.Label.Title": "Title of the webinar",
    "Webinar.Schedule.PageHeading": "Schedule your webinar",
    "Webinar.Edit.PageHeading": "Edit your webinar",
    "Webinar.Schedule.Warning.DateFuture": "Broadcast date must be in the future",
    "Webinar.Schedule.Warning.DateRequired": "Broadcast date is required",
    "Webinar.Schedule.Warning.DurationMaximum": "Please select a duration no longer than {{maxDuration}}",
    "Webinar.Schedule.Warning.DurationMinimum": "The minimal duration is {{minDuration}} minutes",
    "Webinar.Schedule.Warning.NameMax": "Name can not be longer than 350 characters",
    "Webinar.Schedule.Warning.NameMin": "Name must be at least 3 characters",
    "Webinar.Schedule.Warning.NameRequired": "Name is required",
    "Webinar.Schedule.Warning.Timeslot": "The requested timeslot is not available",
    "Webinar.Schedule.Warning.TitleMax": "Title can not be longer than 350 characters",
    "Webinar.Schedule.Warning.TitleMin": "Title must be at least 3 characters",
    "Webinar.Schedule.Warning.TitleRequired": "Title is required",

    "WebinarUpNext.Button.Share": "Share",
    "WebinarUpNext.Button.StartBroadcast": "Start broadcast",
    "WebinarUpNext.Button.Test": "Test connection",
    "WebinarUpNext.Heading.UpNext": "Up next",

    "Javascript.Required": "This application requires JavaScript to run. Please enable JavaScript in your browser settings and refresh the page.",

    "Manage.Link.EmailLists": "Manage e-mail lists",
    "Manage.Link.Blacklist": "Manage blacklist",
    "Manage.Link.UsageStatistics": "View usage",

    "EmailLists.PageHeading": "E-mail lists",
    "EmailLists.Button.Import": "Import a new list",
    "EmailLists.Button.BackToLists": "Back to e-mail lists",
    "EmailLists.Button.BackToCampaign": "Back to the campaign",
    "EmailLists.Heading.YourLists": "Your e-mail lists",
    "EmailLists.Table.Header.Description": "Description",
    "EmailLists.Table.Header.ImportedDate": "Imported on",
    "EmailLists.Table.Header.RecipientCount": "Recipients",
    "EmailLists.Table.Header.SendCount": "Sends",
    "EmailLists.Table.Header.LastSendAt": "Last sent",
    "EmailLists.Table.Header.Status": "Status",
    "EmailLists.Status.Importing": "Importing",
    "EmailLists.Status.Active": "Active",
    "EmailLists.Status.Deleted": "Deleted",
    "EmailLists.Import.PageHeading": "Import a new e-mail list",
    "EmailLists.Import.Label.Description": "List description",
    "EmailLists.Import.Button.Import": "Import list",
    "EmailLists.Import.Error.DescriptionRequired": "Please enter a description for this list",
    "EmailLists.Detail.ImportedDate": "Imported on",
    "EmailLists.Detail.RecipientCount": "Recipients",
    "EmailLists.Detail.Status": "Status",
    "EmailLists.Detail.Button.Send": "Send e-mail",
    "EmailLists.Detail.Button.Delete": "Delete list",
    "EmailLists.Detail.SendLog.Heading": "Send history",
    "EmailLists.Detail.SendLog.Empty": "No e-mails have been sent to this list yet.",
    "EmailLists.Detail.Campaigns.Heading": "Marketing campaigns",
    "EmailLists.Detail.Campaigns.Name": "Campaign",
    "EmailLists.Detail.Campaigns.UsedAt": "Sent on",
    "EmailLists.Detail.Campaigns.View": "View campaign",
    "EmailLists.Detail.SendLog.TemplateType": "Type",
    "EmailLists.Detail.SendLog.SentAt": "Sent on",
    "EmailLists.Detail.SendLog.RecipientCount": "Recipients",
    "EmailLists.Detail.SendLog.SentCount": "Sent",
    "EmailLists.Detail.SendLog.FailedCount": "Failed",
    "EmailLists.Detail.SendLog.BlacklistedCount": "Blacklisted",
    "EmailLists.Detail.SendLog.Actions": "Details",
    "EmailLists.Detail.SendLog.AlreadyInterestedCount": "Already interested",
    "EmailLists.Detail.SendLog.ViewTemplate": "View e-mail",
    "EmailLists.Detail.Tab.Members": "Members",
    "EmailLists.Detail.Tab.SendHistory": "Send history",
    "EmailLists.Detail.Description.Label": "List description",
    "EmailLists.Detail.Description.Edit": "Edit description",
    "EmailLists.Detail.Members.Empty": "This list has no recipients yet.",
    "EmailLists.Detail.Members.Header.Email": "E-mail address",
    "EmailLists.Detail.Members.Header.Name": "Name",
    "EmailLists.Detail.Members.Header.Company": "Company",
    "EmailLists.Detail.Members.RemoveLabel": "Remove {{email}} from the list",
    "EmailLists.Detail.Members.RemoveTitle": "Remove recipient?",
    "EmailLists.Detail.Members.RemoveBody": "Are you sure you want to remove {{email}} from this list?",
    "EmailLists.Detail.Members.RemoveConfirm": "Remove",
    "EmailLists.Detail.Members.Locked": "This list has already been used to send e-mail, so its recipients can no longer be changed.",
    "EmailLists.Detail.Append.Heading": "Add more recipients",
    "EmailLists.Detail.Append.Intro": "Import another file to add recipients to this list. Duplicate e-mail addresses are skipped automatically.",
    "EmailLists.Detail.Append.Button": "Add to list",
    "EmailLists.TemplateType.EmailList": "General e-mail",
    "EmailLists.TemplateType.WebinarEmailList": "Webinar e-mail",
    "EmailLists.Send.Title": "Send an e-mail to this list",
    "EmailLists.Send.TemplateTypeLabel": "Which e-mail would you like to send?",
    "EmailLists.Send.WebinarLabel": "Choose a webinar",
    "EmailLists.Send.WebinarPlaceholder": "Select a webinar...",
    "EmailLists.Send.WebinarGroup.Upcoming": "Upcoming webinars",
    "EmailLists.Send.WebinarGroup.Ended": "Ended webinars",
    "EmailLists.Send.AlreadySentWarning": "This type of e-mail has already been sent to this list.",
    "EmailLists.Send.AudienceHeading": "Audience",
    "EmailLists.Send.ExcludeInterested": "Exclude accounts already interested in this webinar",
    "EmailLists.Send.AlreadyInterested": "Already interested",
    "EmailLists.Send.AlreadyInterestedSummary": "{{count}} of {{total}} recipients are already interested in this webinar",
    "EmailLists.Send.ExcludedSuffix": "they'll be excluded from this send",
    "EmailLists.Send.PublishWebinarFirst": "Publish the webinar before you can send.",
    "EmailLists.Send.SubjectLabel": "Subject",
    "EmailLists.Send.BodyLabel": "Message",
    "EmailLists.Send.Confirm": "Send",
    "EmailLists.View.Title": "E-mail that was sent",
    "EmailLists.Delete.Title": "Delete this e-mail list?",
    "EmailLists.Delete.Body.Unused": "This will permanently delete the list and all its recipients. This action cannot be undone.",
    "EmailLists.Delete.Body.Used": "This list has already been used to send e-mail. Its recipients' personal data will be erased, but a record of the sends is kept for your audit history. This action cannot be undone.",
    "EmailLists.Delete.Confirm": "Delete list",

    "Blacklist.PageHeading": "Blacklist",
    "Blacklist.Search.Label": "Search by e-mail address",
    "Blacklist.Search.Placeholder": "Search...",
    "Blacklist.Table.Header.Email": "E-mail address",
    "Blacklist.Table.Header.BlacklistedAt": "Blacklisted on",
    "Blacklist.Table.Header.Source": "Source",
    "Blacklist.Source.UnsubscribeLink": "Unsubscribe link",
    "Blacklist.Source.AdminUi": "Administrator",
    "Blacklist.Source.ProfileToggle": "Profile setting",
    "Blacklist.Button.Remove": "Remove {{email}} from the blacklist",
    "Blacklist.Empty": "No blacklisted e-mail addresses found.",
    "Blacklist.Remove.Title": "Remove from blacklist?",
    "Blacklist.Remove.Body": "Are you sure you want to remove {{email}} from the blacklist?",
    "Blacklist.Remove.Confirm": "Remove",

    "UsageStatistics.PageHeading": "Usage statistics",
    "UsageStatistics.Range.ThisMonth": "This month",
    "UsageStatistics.Range.LastMonth": "Last month",
    "UsageStatistics.Range.ThisQuarter": "This quarter",
    "UsageStatistics.Range.ThisYear": "This year",
    "UsageStatistics.Today.Heading": "Today so far",
    "UsageStatistics.Provisional": "Today is not frozen yet: these figures are provisional and are not part of the range totals or the export.",
    "UsageStatistics.DaysMissing": "{{count}} day(s) in this range have no data yet.",
    "UsageStatistics.ApproximateOnDemand": "On-demand publication dates before rollout are approximated from the broadcast date.",
    "UsageStatistics.Export": "Export to Excel",
    "UsageStatistics.StockDelta": "{{change}} in this range",
    "UsageStatistics.NoStockBaseline": "There is no data for the day before this range, so the change across the range cannot be shown. The levels themselves are unaffected.",
    "UsageStatistics.Metric.LiveWebinars": "Live webinars",
    "UsageStatistics.Metric.WebinarMinutes": "Webinar minutes",
    "UsageStatistics.Metric.LiveViewers": "Live attendances",
    "UsageStatistics.Metric.LiveWatchMinutes": "Live watch minutes",
    "UsageStatistics.Metric.OnDemandViewers": "On-demand viewing sessions",
    "UsageStatistics.Metric.OnDemandWatchMinutes": "On-demand watch minutes",
    "UsageStatistics.Metric.OnDemandCatalogue": "On-demand catalogue",
    "UsageStatistics.Metric.StorageBytes": "Storage used (bytes)",
    "UsageStatistics.Metric.TestWebinars": "Test webinars",
    "UsageStatistics.Filter.From": "From",
    "UsageStatistics.Filter.To": "To",
    "UsageStatistics.Chart.LiveWebinarsPerWeek": "Live webinars per week",
    "UsageStatistics.Chart.NoData": "No frozen days with data in this range yet.",
    "UsageStatistics.Billing.Heading": "Billable webinar hours",
    "UsageStatistics.Billing.BlockSize": "Counted in blocks of {{size}} viewers",
    "UsageStatistics.Billing.Allowance": "Agreed: {{hours}} hours per month",
    "UsageStatistics.Billing.MonthsOver": "{{count}} of the last 12 months exceeded the agreed hours",
    "UsageStatistics.Billing.Webinar": "Webinar",
    "UsageStatistics.Billing.PeakViewers": "Peak viewers",
    "UsageStatistics.Billing.Blocks": "Blocks",
    "UsageStatistics.Billing.BillableMinutes": "Billable minutes",

    "Unsubscribe.Error.Title": "Something went wrong",
    "Unsubscribe.Success.Title": "You have been unsubscribed",
    "Unsubscribe.Success.Body": "You won't receive unsolicited e-mail from {{brand}} anymore.",
    "Unsubscribe.Resubscribe.Prompt": "Didn't mean to unsubscribe?",
    "Unsubscribe.Resubscribe.Button": "Re-subscribe",
    "Unsubscribe.Resubscribed.Title": "You have been re-subscribed",
    "Unsubscribe.Resubscribed.Body": "You will receive e-mail from {{brand}} again.",

    "EmailPreferences.PageHeading": "E-mail preferences",
    "EmailPreferences.Description": "Manage whether you receive unsolicited e-mail from this environment.",
    "EmailPreferences.Toggle.Label": "Unsubscribe me from unsolicited e-mail",

    "ChatLinkDomains.PageHeading": "Chat link domains",
    "ChatLinkDomains.Intro": "Links in chat messages open directly for domains on the allow-list; every other link shows a warning first. Domains on the block-list cannot be posted, and links to them in older messages stop being clickable. Every link is still checked for malware and phishing, also allow-listed ones — the allow-list expresses trust, including for links posted in the past. Do not allow-list URL shorteners or sites with open redirects.",
    "ChatLinkDomains.AllowedDomains.Label": "Allow-list",
    "ChatLinkDomains.AllowedDomains.Help": "One domain per line, for example example.com. Sub-domains are included.",
    "ChatLinkDomains.BlockedDomains.Label": "Block-list",
    "ChatLinkDomains.BlockedDomains.Help": "One domain per line. A blocked sub-domain wins over an allowed parent domain.",
    "ChatLinkDomains.Save": "Save",
    "ChatLinkDomains.Save.Success": "The domain lists have been saved.",
    "ChatLinkDomains.Save.Error": "The domain lists could not be saved.",
    "Manage.Link.ChatLinkDomains": "Manage chat link domains",
    "Chat.Message.LinkNotAllowed": "Your message couldn't be sent because it contains a link that isn't allowed. Please edit or remove the link and try again.",
    "Chat.Message.TooManyLinks": "A message can contain at most 10 links.",
    "Chat.LinkWarning.Title": "Unverified link",
    "Chat.LinkWarning.Body": "This link leads to a website we haven't verified. Do you want to continue to <strong>{{hostname}}</strong>? It will open in a new tab.",
    "Chat.LinkWarning.Continue": "Continue"
}
